(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["bits/abilities"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"oauth-abilities\" data-field-name=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "field_name"), env.opts.autoescape);
output += "\">\n    <input type=\"hidden\" class=\"scan-empty\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "field_name"), env.opts.autoescape);
output += "\" />\n    ";
if(runtime.contextOrFrameLookup(context, frame, "abilities")) {
output += "\n    ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "abilities");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("ability", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("bits/ability", false, "bits/abilities", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
callback(null,t_5);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
callback(null,t_7);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    ";
});
}
}
frame = frame.pop();
output += "\n    ";
;
}
output += "\n    <p>\n        <a class=\"btn btn-success btn-add-ability\" aria-label=\"Add ability\">\n            <i class=\"fas fa-plus\"></i>\n        </a>\n    </p>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["bits/ability"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"input-group mb-3 ability-entry\">\n    <div class=\"input-group-prepend\">\n        <a class=\"btn btn-outline-secondary btn-delete-ability\" aria-label=\"Remove\" title=\"Remove\">\n            <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-times\"></i>\n        </a>\n    </div>\n    <input type=\"text\" class=\"form-control\" name=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "field_name"), env.opts.autoescape);
output += "[]\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ability"), env.opts.autoescape);
output += "\" />\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["bits/feed-entry"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"activity-feed-entry\">\n    <div class=\"row\">\n        <div class=\"af-timestamp col col-lg-3 col-md-4 col-sm-12 col-xs-12\">\n            <span class=\"timeago only\" data-timestamp=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "now"), env.opts.autoescape);
output += "\"></span>\n        </div>\n        <div class=\"af-event-descr col col-lg-9 col-md-8 col-sm-12 col-xs-12\">\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"thing") == "host" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"event") == "seen") {
output += "\n                ";
if(runtime.contextOrFrameLookup(context, frame, "host") != null) {
output += "\n                    Host\n                    <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"host"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"name"), env.opts.autoescape);
output += "</a>\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"via") == "dhcp") {
output += "\n                        seen on interface\n                        <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"host"), env.opts.autoescape);
output += "/interface/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"iface"), env.opts.autoescape);
output += "\">\n                            <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iftypes")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iface")),"type"))),"icon"), env.opts.autoescape);
output += " last-iface-type\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iftypes")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iface")),"type"))),"label"), env.opts.autoescape);
output += "\"></i>\n                            <span class=\"last-iface-name\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iface")),"name"), env.opts.autoescape);
output += "</span>\n                        </a>\n                        at IP address\n                        <strong>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"ip"), env.opts.autoescape);
output += "</strong>\n                    ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"via") == "mdm") {
output += "\n                        checked in to MDM\n                    ";
;
}
else {
output += "\n                        seen via ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"via"), env.opts.autoescape);
output += "\n                    ";
;
}
;
}
output += "\n                ";
;
}
else {
output += "\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"via") == "dhcp") {
output += "\n                        Unknown device with MAC address <tt>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"mac"), env.opts.autoescape);
output += "</tt> seen at\n                        IP address ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"ip"), env.opts.autoescape);
output += "\n                    ";
;
}
else {
output += "\n                        Unknown host/seen event: ";
output += runtime.suppressValue(env.getFilter("dump").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")), env.opts.autoescape);
output += "\n                    ";
;
}
output += "\n                ";
;
}
output += "\n            ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"thing") == "host") {
output += "\n                Host\n                <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"host"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"name"), env.opts.autoescape);
output += "</a>\n                was ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"event"), env.opts.autoescape);
output += "\n            ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"thing") == "domain") {
output += "\n                A domain\n                was ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"event"), env.opts.autoescape);
output += "\n            ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"thing") == "user") {
output += "\n                User\n                <a rel=\"internal\" href=\"user/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"user"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"user"), env.opts.autoescape);
output += "</a>\n                was ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"event"), env.opts.autoescape);
output += "\n            ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"thing") == "mdm_command") {
output += "\n                ";
if(runtime.contextOrFrameLookup(context, frame, "host") != null) {
output += "\n                    Host\n                    <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"host"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"name"), env.opts.autoescape);
output += "</a>\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"event") == "created") {
output += "\n                        was assigned an MDM\n                        <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"host"), env.opts.autoescape);
output += "/mdm/command/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"mdm_command"), env.opts.autoescape);
output += "\">";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm_command")),"args")),"RequestType")) {
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm_command")),"args")),"RequestType"), env.opts.autoescape);
;
}
output += "\n                            command\n                        </a>\n                    ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"event") == "updated") {
output += "\n                        actioned an MDM\n                        <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"host"), env.opts.autoescape);
output += "/mdm/command/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags")),"mdm_command"), env.opts.autoescape);
output += "\">";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm_command")),"args")),"RequestType")) {
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm_command")),"args")),"RequestType"), env.opts.autoescape);
;
}
output += "\n                            command\n                        </a>\n                    ";
;
}
;
}
output += "\n                ";
;
}
else {
output += "\n                    <em>Error displaying mdm_command: <tt>host</tt> is null</em>\n                ";
;
}
output += "\n            ";
;
}
else {
output += "\n                Unhandled event type: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"thing"), env.opts.autoescape);
output += "/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"event"), env.opts.autoescape);
output += ";\n                tags:\n                ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "event")),"tags");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_1;
if(runtime.isArray(t_3)) {
var t_2 = t_3.length;
for(t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1][0];
frame.set("[object Object]", t_3[t_1][0]);
var t_5 = t_3[t_1][1];
frame.set("[object Object]", t_3[t_1][1]);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                    ";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "=";
output += runtime.suppressValue(t_5, env.opts.autoescape);
output += ";\n                ";
;
}
} else {
t_1 = -1;
var t_2 = runtime.keys(t_3).length;
for(var t_6 in t_3) {
t_1++;
var t_7 = t_3[t_6];
frame.set("key", t_6);
frame.set("value", t_7);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                    ";
output += runtime.suppressValue(t_6, env.opts.autoescape);
output += "=";
output += runtime.suppressValue(t_7, env.opts.autoescape);
output += ";\n                ";
;
}
}
}
frame = frame.pop();
output += "\n                <br />\n                Raw: ";
output += runtime.suppressValue(env.getFilter("dump").call(context, runtime.contextOrFrameLookup(context, frame, "event")), env.opts.autoescape);
output += "\n            ";
;
}
;
}
;
}
;
}
;
}
output += "\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["bits/forms"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["value", "label"], 
["icon", "current"], 
function (l_value, l_label, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("value", l_value);
frame.set("label", l_label);
frame.set("icon", Object.prototype.hasOwnProperty.call(kwargs, "icon") ? kwargs["icon"] : null);frame.set("current", Object.prototype.hasOwnProperty.call(kwargs, "current") ? kwargs["current"] : null);var t_2 = "";t_2 += "\n<option ";
if(runtime.contextOrFrameLookup(context, frame, "current") == l_value) {
t_2 += "selected=\"selected\"";
;
}
t_2 += " value=\"";
t_2 += runtime.suppressValue(l_value, env.opts.autoescape);
t_2 += "\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "icon")) {
t_2 += "<i class=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
t_2 += " fa-";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "icon"), env.opts.autoescape);
t_2 += "\"></i>";
;
}
t_2 += "\n    ";
t_2 += runtime.suppressValue(l_label, env.opts.autoescape);
t_2 += "\n</option>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("option");
context.setVariable("option", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["bits/tag-entry"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"form-group row\">\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tag")),"name")) {
output += "\n        <label for=\"input-tag-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tag")),"name"), env.opts.autoescape);
output += "\" class=\"col-sm-2 col-form-label\">\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tag")),"name"), env.opts.autoescape);
output += ":\n        </label>\n    ";
;
}
else {
output += "\n        <div class=\"col-sm-2\">\n            <input type=\"text\" class=\"form-control\" name=\"new_tags_names[]\">\n        </div>\n    ";
;
}
output += "\n    <div class=\"col-sm-10\">\n        <input type=\"text\" class=\"form-control\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tag")),"name")) {
output += "name=\"tags[";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tag")),"name"), env.opts.autoescape);
output += "]\" data-tag-name=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tag")),"name"), env.opts.autoescape);
output += "\"";
;
}
else {
output += "name=\"new_tags_values[]\"";
;
}
output += " value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tag")),"value"), env.opts.autoescape);
output += "\">\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["dns/edit"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("bits/forms", false, "dns/edit", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("forms", t_1);
output += "\n<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-desktop\"></i>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        Edit DNS record: ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rname"), env.opts.autoescape);
output += ".";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"name"), env.opts.autoescape);
output += "\n        ";
;
}
else {
output += "\n        Create DNS record\n        ";
;
}
output += "\n    </h4>\n    <div class=\"col text-right\">\n        <a class=\"btn btn-info btn-cancel-edits\" href=\"dns\" rel=\"internal\">\n            <i class=\"fas fa-undo-alt\"></i>\n            Return to Record List\n        </a>\n    </div>\n</div>\n\n<div class=\"row py-3\">\n    <div class=\"col\">\n        <form name=\"record\" method=\"";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "put";
;
}
else {
output += "post";
;
}
output += "\" data-transport=\"api\" action=\"record";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
;
}
output += "\" class=\"form-horizontal\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-record-id\" class=\"col-sm-2 col-form-label\">\n                    ID:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input readonly=\"readonly\" name=\"id\" type=\"text\" class=\"form-control\" id=\"input-record-id\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            ";
;
}
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-client-name\" class=\"col-sm-2 col-form-label\">\n                    Record name:\n                </label>\n                <div class=\"col-sm-10\">\n                    <div class=\"input-group\">\n                        <input name=\"rname\" type=\"text\" class=\"form-control\" id=\"input-client-name\" placeholder=\"enterprise\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rname"), env.opts.autoescape);
output += "\" />\n                        <select class=\"form-control\" name=\"domain\">\n                            ";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "domains");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("cur_domain", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n                                ";
output += runtime.suppressValue((lineno = 40, colno = 46, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [runtime.memberLookup((t_7),"id"),"." + runtime.memberLookup((t_7),"name"),null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"id")])), env.opts.autoescape);
output += "\n                            ";
;
}
}
frame = frame.pop();
output += "\n                        </select>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"form-group row\">\n                <label for=\"input-client-name\" class=\"col-sm-2 col-form-label\">\n                    Record type:\n                </label>\n                <div class=\"col-sm-10\">\n                    ";
frame = frame.push();
var t_10 = runtime.contextOrFrameLookup(context, frame, "schema");
if(t_10) {t_10 = runtime.fromIterator(t_10);
var t_8;
if(runtime.isArray(t_10)) {
var t_9 = t_10.length;
for(t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8][0];
frame.set("[object Object]", t_10[t_8][0]);
var t_12 = t_10[t_8][1];
frame.set("[object Object]", t_10[t_8][1]);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += "\n                        <div class=\"form-check form-check-inline\">\n                            <label class=\"form-check-label\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"type\" value=\"";
output += runtime.suppressValue(t_11, env.opts.autoescape);
output += "\" ";
if(t_11 == runtime.contextOrFrameLookup(context, frame, "type")) {
output += "checked=\"checked\"";
;
}
output += " />\n                                ";
output += runtime.suppressValue(t_11, env.opts.autoescape);
output += "\n                            </label>\n                        </div>\n                    ";
;
}
} else {
t_8 = -1;
var t_9 = runtime.keys(t_10).length;
for(var t_13 in t_10) {
t_8++;
var t_14 = t_10[t_13];
frame.set("rtype", t_13);
frame.set("_", t_14);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += "\n                        <div class=\"form-check form-check-inline\">\n                            <label class=\"form-check-label\">\n                                <input class=\"form-check-input\" type=\"radio\" name=\"type\" value=\"";
output += runtime.suppressValue(t_13, env.opts.autoescape);
output += "\" ";
if(t_13 == runtime.contextOrFrameLookup(context, frame, "type")) {
output += "checked=\"checked\"";
;
}
output += " />\n                                ";
output += runtime.suppressValue(t_13, env.opts.autoescape);
output += "\n                            </label>\n                        </div>\n                    ";
;
}
}
}
frame = frame.pop();
output += "\n                </div>\n            </div>\n\n            <div class=\"form-group row\">\n                <label for=\"input-record-ttl\" class=\"col-sm-2 col-form-label\">\n                    TTL:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"ttl\" size=\"20\" type=\"text\" class=\"form-control\" id=\"input-record-ttl\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ttl"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n\n            <div class=\"form-group row\">\n                <label for=\"input-record-owner\" class=\"col-sm-2 col-form-label\">\n                    Owner:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input ";
if(!runtime.contextOrFrameLookup(context, frame, "id") && !runtime.inOperator("dns.admin",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"abilities")) && !runtime.inOperator("superadmin",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"abilities"))) {
output += "readonly=\"readonly\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"identity"), env.opts.autoescape);
output += "\"";
;
}
else {
output += "value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "owner"), env.opts.autoescape);
output += "\"";
;
}
output += "\n                            name=\"owner\" type=\"text\" class=\"form-control\" id=\"input-record-owner\" placeholder=\"jtkirk\" />\n                </div>\n            </div>\n\n            <fieldset>\n                <legend>Record data</legend>\n                ";
frame = frame.push();
var t_17 = runtime.contextOrFrameLookup(context, frame, "schema");
if(t_17) {t_17 = runtime.fromIterator(t_17);
var t_15;
if(runtime.isArray(t_17)) {
var t_16 = t_17.length;
for(t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15][0];
frame.set("[object Object]", t_17[t_15][0]);
var t_19 = t_17[t_15][1];
frame.set("[object Object]", t_17[t_15][1]);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\n                    ";
frame = frame.push();
var t_22 = t_19;
if(t_22) {t_22 = runtime.fromIterator(t_22);
var t_20;
if(runtime.isArray(t_22)) {
var t_21 = t_22.length;
for(t_20=0; t_20 < t_22.length; t_20++) {
var t_23 = t_22[t_20][0];
frame.set("[object Object]", t_22[t_20][0]);
var t_24 = t_22[t_20][1];
frame.set("[object Object]", t_22[t_20][1]);
frame.set("loop.index", t_20 + 1);
frame.set("loop.index0", t_20);
frame.set("loop.revindex", t_21 - t_20);
frame.set("loop.revindex0", t_21 - t_20 - 1);
frame.set("loop.first", t_20 === 0);
frame.set("loop.last", t_20 === t_21 - 1);
frame.set("loop.length", t_21);
output += "\n                        <div class=\"form-group row show-if-record-type-is type-";
output += runtime.suppressValue((lineno = 86, colno = 98, runtime.callWrap(runtime.memberLookup((t_18),"toLowerCase"), "rtype[\"toLowerCase\"]", context, [])), env.opts.autoescape);
output += "\">\n                            <label for=\"input-record-";
output += runtime.suppressValue(t_18, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 87, colno = 78, runtime.callWrap(runtime.memberLookup((t_23),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\" class=\"col-sm-2 col-form-label\">\n                                ";
output += runtime.suppressValue(t_23, env.opts.autoescape);
output += ":\n                            </label>\n                            <div class=\"col-sm-10\">\n                                ";
if(runtime.memberLookup((t_24),"type") == "enum") {
output += "\n                                <select class=\"form-control\" name=\"rdata[";
output += runtime.suppressValue(t_23, env.opts.autoescape);
output += "]\">\n                                    ";
frame = frame.push();
var t_27 = runtime.memberLookup((t_24),"values");
if(t_27) {t_27 = runtime.fromIterator(t_27);
var t_25;
if(runtime.isArray(t_27)) {
var t_26 = t_27.length;
for(t_25=0; t_25 < t_27.length; t_25++) {
var t_28 = t_27[t_25][0];
frame.set("[object Object]", t_27[t_25][0]);
var t_29 = t_27[t_25][1];
frame.set("[object Object]", t_27[t_25][1]);
frame.set("loop.index", t_25 + 1);
frame.set("loop.index0", t_25);
frame.set("loop.revindex", t_26 - t_25);
frame.set("loop.revindex0", t_26 - t_25 - 1);
frame.set("loop.first", t_25 === 0);
frame.set("loop.last", t_25 === t_26 - 1);
frame.set("loop.length", t_26);
output += "\n                                    ";
output += runtime.suppressValue((lineno = 94, colno = 51, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_28,t_29,null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_23)])), env.opts.autoescape);
output += "\n                                    ";
;
}
} else {
t_25 = -1;
var t_26 = runtime.keys(t_27).length;
for(var t_30 in t_27) {
t_25++;
var t_31 = t_27[t_30];
frame.set("value", t_30);
frame.set("valuename", t_31);
frame.set("loop.index", t_25 + 1);
frame.set("loop.index0", t_25);
frame.set("loop.revindex", t_26 - t_25);
frame.set("loop.revindex0", t_26 - t_25 - 1);
frame.set("loop.first", t_25 === 0);
frame.set("loop.last", t_25 === t_26 - 1);
frame.set("loop.length", t_26);
output += "\n                                    ";
output += runtime.suppressValue((lineno = 94, colno = 51, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_30,t_31,null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_23)])), env.opts.autoescape);
output += "\n                                    ";
;
}
}
}
frame = frame.pop();
output += "\n                                </select>\n                                ";
;
}
else {
if(runtime.memberLookup((t_24),"type") == "int") {
output += "\n                                <input name=\"rdata[";
output += runtime.suppressValue(t_23, env.opts.autoescape);
output += "]\"\n                                    size=\"20\"\n                                    type=\"number\"\n                                    class=\"form-control\"\n                                    id=\"input-record-";
output += runtime.suppressValue(t_18, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 102, colno = 78, runtime.callWrap(runtime.memberLookup((t_23),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\"\n                                    value=\"";
if(runtime.contextOrFrameLookup(context, frame, "type") == t_18) {
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_23), env.opts.autoescape);
;
}
output += "\"\n                                    ";
if(runtime.memberLookup((t_24),"range")) {
output += "\n                                    min=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_24),"range")),0), env.opts.autoescape);
output += "\"\n                                    max=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_24),"range")),1), env.opts.autoescape);
output += "\"\n                                    ";
;
}
output += "\n                                    />\n                                ";
;
}
else {
output += "\n                                <input name=\"rdata[";
output += runtime.suppressValue(t_23, env.opts.autoescape);
output += "]\" size=\"20\" type=\"text\" class=\"form-control\" id=\"input-record-";
output += runtime.suppressValue(t_18, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 110, colno = 148, runtime.callWrap(runtime.memberLookup((t_23),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\" value=\"";
if(runtime.contextOrFrameLookup(context, frame, "type") == t_18) {
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_23), env.opts.autoescape);
;
}
output += "\" />\n                                ";
;
}
;
}
output += "\n                            </div>\n                        </div>\n                    ";
;
}
} else {
t_20 = -1;
var t_21 = runtime.keys(t_22).length;
for(var t_32 in t_22) {
t_20++;
var t_33 = t_22[t_32];
frame.set("label", t_32);
frame.set("spec", t_33);
frame.set("loop.index", t_20 + 1);
frame.set("loop.index0", t_20);
frame.set("loop.revindex", t_21 - t_20);
frame.set("loop.revindex0", t_21 - t_20 - 1);
frame.set("loop.first", t_20 === 0);
frame.set("loop.last", t_20 === t_21 - 1);
frame.set("loop.length", t_21);
output += "\n                        <div class=\"form-group row show-if-record-type-is type-";
output += runtime.suppressValue((lineno = 86, colno = 98, runtime.callWrap(runtime.memberLookup((t_18),"toLowerCase"), "rtype[\"toLowerCase\"]", context, [])), env.opts.autoescape);
output += "\">\n                            <label for=\"input-record-";
output += runtime.suppressValue(t_18, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 87, colno = 78, runtime.callWrap(runtime.memberLookup((t_32),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\" class=\"col-sm-2 col-form-label\">\n                                ";
output += runtime.suppressValue(t_32, env.opts.autoescape);
output += ":\n                            </label>\n                            <div class=\"col-sm-10\">\n                                ";
if(runtime.memberLookup((t_33),"type") == "enum") {
output += "\n                                <select class=\"form-control\" name=\"rdata[";
output += runtime.suppressValue(t_32, env.opts.autoescape);
output += "]\">\n                                    ";
frame = frame.push();
var t_36 = runtime.memberLookup((t_33),"values");
if(t_36) {t_36 = runtime.fromIterator(t_36);
var t_34;
if(runtime.isArray(t_36)) {
var t_35 = t_36.length;
for(t_34=0; t_34 < t_36.length; t_34++) {
var t_37 = t_36[t_34][0];
frame.set("[object Object]", t_36[t_34][0]);
var t_38 = t_36[t_34][1];
frame.set("[object Object]", t_36[t_34][1]);
frame.set("loop.index", t_34 + 1);
frame.set("loop.index0", t_34);
frame.set("loop.revindex", t_35 - t_34);
frame.set("loop.revindex0", t_35 - t_34 - 1);
frame.set("loop.first", t_34 === 0);
frame.set("loop.last", t_34 === t_35 - 1);
frame.set("loop.length", t_35);
output += "\n                                    ";
output += runtime.suppressValue((lineno = 94, colno = 51, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_37,t_38,null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_32)])), env.opts.autoescape);
output += "\n                                    ";
;
}
} else {
t_34 = -1;
var t_35 = runtime.keys(t_36).length;
for(var t_39 in t_36) {
t_34++;
var t_40 = t_36[t_39];
frame.set("value", t_39);
frame.set("valuename", t_40);
frame.set("loop.index", t_34 + 1);
frame.set("loop.index0", t_34);
frame.set("loop.revindex", t_35 - t_34);
frame.set("loop.revindex0", t_35 - t_34 - 1);
frame.set("loop.first", t_34 === 0);
frame.set("loop.last", t_34 === t_35 - 1);
frame.set("loop.length", t_35);
output += "\n                                    ";
output += runtime.suppressValue((lineno = 94, colno = 51, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_39,t_40,null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_32)])), env.opts.autoescape);
output += "\n                                    ";
;
}
}
}
frame = frame.pop();
output += "\n                                </select>\n                                ";
;
}
else {
if(runtime.memberLookup((t_33),"type") == "int") {
output += "\n                                <input name=\"rdata[";
output += runtime.suppressValue(t_32, env.opts.autoescape);
output += "]\"\n                                    size=\"20\"\n                                    type=\"number\"\n                                    class=\"form-control\"\n                                    id=\"input-record-";
output += runtime.suppressValue(t_18, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 102, colno = 78, runtime.callWrap(runtime.memberLookup((t_32),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\"\n                                    value=\"";
if(runtime.contextOrFrameLookup(context, frame, "type") == t_18) {
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_32), env.opts.autoescape);
;
}
output += "\"\n                                    ";
if(runtime.memberLookup((t_33),"range")) {
output += "\n                                    min=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_33),"range")),0), env.opts.autoescape);
output += "\"\n                                    max=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_33),"range")),1), env.opts.autoescape);
output += "\"\n                                    ";
;
}
output += "\n                                    />\n                                ";
;
}
else {
output += "\n                                <input name=\"rdata[";
output += runtime.suppressValue(t_32, env.opts.autoescape);
output += "]\" size=\"20\" type=\"text\" class=\"form-control\" id=\"input-record-";
output += runtime.suppressValue(t_18, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 110, colno = 148, runtime.callWrap(runtime.memberLookup((t_32),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\" value=\"";
if(runtime.contextOrFrameLookup(context, frame, "type") == t_18) {
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_32), env.opts.autoescape);
;
}
output += "\" />\n                                ";
;
}
;
}
output += "\n                            </div>\n                        </div>\n                    ";
;
}
}
}
frame = frame.pop();
output += "\n                ";
;
}
} else {
t_15 = -1;
var t_16 = runtime.keys(t_17).length;
for(var t_41 in t_17) {
t_15++;
var t_42 = t_17[t_41];
frame.set("rtype", t_41);
frame.set("fields", t_42);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\n                    ";
frame = frame.push();
var t_45 = t_42;
if(t_45) {t_45 = runtime.fromIterator(t_45);
var t_43;
if(runtime.isArray(t_45)) {
var t_44 = t_45.length;
for(t_43=0; t_43 < t_45.length; t_43++) {
var t_46 = t_45[t_43][0];
frame.set("[object Object]", t_45[t_43][0]);
var t_47 = t_45[t_43][1];
frame.set("[object Object]", t_45[t_43][1]);
frame.set("loop.index", t_43 + 1);
frame.set("loop.index0", t_43);
frame.set("loop.revindex", t_44 - t_43);
frame.set("loop.revindex0", t_44 - t_43 - 1);
frame.set("loop.first", t_43 === 0);
frame.set("loop.last", t_43 === t_44 - 1);
frame.set("loop.length", t_44);
output += "\n                        <div class=\"form-group row show-if-record-type-is type-";
output += runtime.suppressValue((lineno = 86, colno = 98, runtime.callWrap(runtime.memberLookup((t_41),"toLowerCase"), "rtype[\"toLowerCase\"]", context, [])), env.opts.autoescape);
output += "\">\n                            <label for=\"input-record-";
output += runtime.suppressValue(t_41, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 87, colno = 78, runtime.callWrap(runtime.memberLookup((t_46),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\" class=\"col-sm-2 col-form-label\">\n                                ";
output += runtime.suppressValue(t_46, env.opts.autoescape);
output += ":\n                            </label>\n                            <div class=\"col-sm-10\">\n                                ";
if(runtime.memberLookup((t_47),"type") == "enum") {
output += "\n                                <select class=\"form-control\" name=\"rdata[";
output += runtime.suppressValue(t_46, env.opts.autoescape);
output += "]\">\n                                    ";
frame = frame.push();
var t_50 = runtime.memberLookup((t_47),"values");
if(t_50) {t_50 = runtime.fromIterator(t_50);
var t_48;
if(runtime.isArray(t_50)) {
var t_49 = t_50.length;
for(t_48=0; t_48 < t_50.length; t_48++) {
var t_51 = t_50[t_48][0];
frame.set("[object Object]", t_50[t_48][0]);
var t_52 = t_50[t_48][1];
frame.set("[object Object]", t_50[t_48][1]);
frame.set("loop.index", t_48 + 1);
frame.set("loop.index0", t_48);
frame.set("loop.revindex", t_49 - t_48);
frame.set("loop.revindex0", t_49 - t_48 - 1);
frame.set("loop.first", t_48 === 0);
frame.set("loop.last", t_48 === t_49 - 1);
frame.set("loop.length", t_49);
output += "\n                                    ";
output += runtime.suppressValue((lineno = 94, colno = 51, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_51,t_52,null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_46)])), env.opts.autoescape);
output += "\n                                    ";
;
}
} else {
t_48 = -1;
var t_49 = runtime.keys(t_50).length;
for(var t_53 in t_50) {
t_48++;
var t_54 = t_50[t_53];
frame.set("value", t_53);
frame.set("valuename", t_54);
frame.set("loop.index", t_48 + 1);
frame.set("loop.index0", t_48);
frame.set("loop.revindex", t_49 - t_48);
frame.set("loop.revindex0", t_49 - t_48 - 1);
frame.set("loop.first", t_48 === 0);
frame.set("loop.last", t_48 === t_49 - 1);
frame.set("loop.length", t_49);
output += "\n                                    ";
output += runtime.suppressValue((lineno = 94, colno = 51, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_53,t_54,null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_46)])), env.opts.autoescape);
output += "\n                                    ";
;
}
}
}
frame = frame.pop();
output += "\n                                </select>\n                                ";
;
}
else {
if(runtime.memberLookup((t_47),"type") == "int") {
output += "\n                                <input name=\"rdata[";
output += runtime.suppressValue(t_46, env.opts.autoescape);
output += "]\"\n                                    size=\"20\"\n                                    type=\"number\"\n                                    class=\"form-control\"\n                                    id=\"input-record-";
output += runtime.suppressValue(t_41, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 102, colno = 78, runtime.callWrap(runtime.memberLookup((t_46),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\"\n                                    value=\"";
if(runtime.contextOrFrameLookup(context, frame, "type") == t_41) {
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_46), env.opts.autoescape);
;
}
output += "\"\n                                    ";
if(runtime.memberLookup((t_47),"range")) {
output += "\n                                    min=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_47),"range")),0), env.opts.autoescape);
output += "\"\n                                    max=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_47),"range")),1), env.opts.autoescape);
output += "\"\n                                    ";
;
}
output += "\n                                    />\n                                ";
;
}
else {
output += "\n                                <input name=\"rdata[";
output += runtime.suppressValue(t_46, env.opts.autoescape);
output += "]\" size=\"20\" type=\"text\" class=\"form-control\" id=\"input-record-";
output += runtime.suppressValue(t_41, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 110, colno = 148, runtime.callWrap(runtime.memberLookup((t_46),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\" value=\"";
if(runtime.contextOrFrameLookup(context, frame, "type") == t_41) {
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_46), env.opts.autoescape);
;
}
output += "\" />\n                                ";
;
}
;
}
output += "\n                            </div>\n                        </div>\n                    ";
;
}
} else {
t_43 = -1;
var t_44 = runtime.keys(t_45).length;
for(var t_55 in t_45) {
t_43++;
var t_56 = t_45[t_55];
frame.set("label", t_55);
frame.set("spec", t_56);
frame.set("loop.index", t_43 + 1);
frame.set("loop.index0", t_43);
frame.set("loop.revindex", t_44 - t_43);
frame.set("loop.revindex0", t_44 - t_43 - 1);
frame.set("loop.first", t_43 === 0);
frame.set("loop.last", t_43 === t_44 - 1);
frame.set("loop.length", t_44);
output += "\n                        <div class=\"form-group row show-if-record-type-is type-";
output += runtime.suppressValue((lineno = 86, colno = 98, runtime.callWrap(runtime.memberLookup((t_41),"toLowerCase"), "rtype[\"toLowerCase\"]", context, [])), env.opts.autoescape);
output += "\">\n                            <label for=\"input-record-";
output += runtime.suppressValue(t_41, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 87, colno = 78, runtime.callWrap(runtime.memberLookup((t_55),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\" class=\"col-sm-2 col-form-label\">\n                                ";
output += runtime.suppressValue(t_55, env.opts.autoescape);
output += ":\n                            </label>\n                            <div class=\"col-sm-10\">\n                                ";
if(runtime.memberLookup((t_56),"type") == "enum") {
output += "\n                                <select class=\"form-control\" name=\"rdata[";
output += runtime.suppressValue(t_55, env.opts.autoescape);
output += "]\">\n                                    ";
frame = frame.push();
var t_59 = runtime.memberLookup((t_56),"values");
if(t_59) {t_59 = runtime.fromIterator(t_59);
var t_57;
if(runtime.isArray(t_59)) {
var t_58 = t_59.length;
for(t_57=0; t_57 < t_59.length; t_57++) {
var t_60 = t_59[t_57][0];
frame.set("[object Object]", t_59[t_57][0]);
var t_61 = t_59[t_57][1];
frame.set("[object Object]", t_59[t_57][1]);
frame.set("loop.index", t_57 + 1);
frame.set("loop.index0", t_57);
frame.set("loop.revindex", t_58 - t_57);
frame.set("loop.revindex0", t_58 - t_57 - 1);
frame.set("loop.first", t_57 === 0);
frame.set("loop.last", t_57 === t_58 - 1);
frame.set("loop.length", t_58);
output += "\n                                    ";
output += runtime.suppressValue((lineno = 94, colno = 51, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_60,t_61,null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_55)])), env.opts.autoescape);
output += "\n                                    ";
;
}
} else {
t_57 = -1;
var t_58 = runtime.keys(t_59).length;
for(var t_62 in t_59) {
t_57++;
var t_63 = t_59[t_62];
frame.set("value", t_62);
frame.set("valuename", t_63);
frame.set("loop.index", t_57 + 1);
frame.set("loop.index0", t_57);
frame.set("loop.revindex", t_58 - t_57);
frame.set("loop.revindex0", t_58 - t_57 - 1);
frame.set("loop.first", t_57 === 0);
frame.set("loop.last", t_57 === t_58 - 1);
frame.set("loop.length", t_58);
output += "\n                                    ";
output += runtime.suppressValue((lineno = 94, colno = 51, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_62,t_63,null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_55)])), env.opts.autoescape);
output += "\n                                    ";
;
}
}
}
frame = frame.pop();
output += "\n                                </select>\n                                ";
;
}
else {
if(runtime.memberLookup((t_56),"type") == "int") {
output += "\n                                <input name=\"rdata[";
output += runtime.suppressValue(t_55, env.opts.autoescape);
output += "]\"\n                                    size=\"20\"\n                                    type=\"number\"\n                                    class=\"form-control\"\n                                    id=\"input-record-";
output += runtime.suppressValue(t_41, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 102, colno = 78, runtime.callWrap(runtime.memberLookup((t_55),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\"\n                                    value=\"";
if(runtime.contextOrFrameLookup(context, frame, "type") == t_41) {
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_55), env.opts.autoescape);
;
}
output += "\"\n                                    ";
if(runtime.memberLookup((t_56),"range")) {
output += "\n                                    min=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_56),"range")),0), env.opts.autoescape);
output += "\"\n                                    max=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_56),"range")),1), env.opts.autoescape);
output += "\"\n                                    ";
;
}
output += "\n                                    />\n                                ";
;
}
else {
output += "\n                                <input name=\"rdata[";
output += runtime.suppressValue(t_55, env.opts.autoescape);
output += "]\" size=\"20\" type=\"text\" class=\"form-control\" id=\"input-record-";
output += runtime.suppressValue(t_41, env.opts.autoescape);
output += "-";
output += runtime.suppressValue((lineno = 110, colno = 148, runtime.callWrap(runtime.memberLookup((t_55),"replace"), "label[\"replace\"]", context, [" ","_"])), env.opts.autoescape);
output += "\" value=\"";
if(runtime.contextOrFrameLookup(context, frame, "type") == t_41) {
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "rdata")),t_55), env.opts.autoescape);
;
}
output += "\" />\n                                ";
;
}
;
}
output += "\n                            </div>\n                        </div>\n                    ";
;
}
}
}
frame = frame.pop();
output += "\n                ";
;
}
}
}
frame = frame.pop();
output += "\n            </fieldset>\n\n            <div class=\"form-group row form-actions\">\n                <div class=\"col-sm-10 offset-sm-2\">\n                    <button type=\"submit\" class=\"btn btn-primary\">\n                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-save\"></i>\n                        Save Record\n                    </button>\n                </div>\n            </div>\n        </form>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        <div class=\"log-container\" data-thing=\"dns_record\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\"></div>\n        ";
;
}
output += "\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["dns/rdata"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "rdata");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_1;
if(runtime.isArray(t_3)) {
var t_2 = t_3.length;
for(t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1][0];
frame.set("[object Object]", t_3[t_1][0]);
var t_5 = t_3[t_1][1];
frame.set("[object Object]", t_3[t_1][1]);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n    <strong>";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += ":</strong> ";
output += runtime.suppressValue(t_5, env.opts.autoescape);
output += "\n";
;
}
} else {
t_1 = -1;
var t_2 = runtime.keys(t_3).length;
for(var t_6 in t_3) {
t_1++;
var t_7 = t_3[t_6];
frame.set("key", t_6);
frame.set("value", t_7);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n    <strong>";
output += runtime.suppressValue(t_6, env.opts.autoescape);
output += ":</strong> ";
output += runtime.suppressValue(t_7, env.opts.autoescape);
output += "\n";
;
}
}
}
frame = frame.pop();
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["domain/edit"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("bits/forms", false, "domain/edit", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("forms", t_1);
output += "\n<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-desktop\"></i>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        Edit domain: ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\n        ";
;
}
else {
output += "\n        Create new domain\n        ";
;
}
output += "\n    </h4>\n    <div class=\"col text-right\">\n        <a class=\"btn btn-info btn-cancel-edits\" href=\"domains\" rel=\"internal\">\n            <i class=\"fas fa-undo-alt\"></i>\n            Return to Domain List\n        </a>\n    </div>\n</div>\n\n<div class=\"row py-3\">\n\t<div class=\"col\">\n        <form name=\"domain\" method=\"";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "put";
;
}
else {
output += "post";
;
}
output += "\" data-transport=\"api\" action=\"domain";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
;
}
output += "\" class=\"form-horizontal\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-domain-id\" class=\"col-sm-2 col-form-label\">\n                    ID:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input readonly=\"readonly\" name=\"id\" type=\"text\" class=\"form-control\" id=\"input-domain-id\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            ";
;
}
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-domain-site\" class=\"col-sm-2 col-form-label\">\n                    Site:\n                </label>\n                <div class=\"col-sm-10\">\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                        <p class=\"form-control-static\" id=\"input-domain-site\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "site")),"name"), env.opts.autoescape);
output += "</p>\n                    ";
;
}
else {
output += "\n                        <select class=\"form-control\" name=\"site\">\n                            ";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "sites");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("site", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n                                ";
output += runtime.suppressValue((lineno = 41, colno = 47, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [runtime.memberLookup((t_7),"id"),runtime.memberLookup((t_7),"name")])), env.opts.autoescape);
output += "\n                            ";
;
}
}
frame = frame.pop();
output += "\n                        </select>\n                        <p class=\"help-block text-muted\">\n                            Can't be changed after the domain is created.\n                        </p>\n                    ";
;
}
output += "\n                </div>\n            </div>\n            <div class=\"form-group row\">\n                <label for=\"input-domain-name\" class=\"col-sm-2 col-form-label\">\n                    Name:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"name\" type=\"text\" class=\"form-control\" id=\"input-domain-name\" placeholder=\"prod.starfleet.net\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            <div class=\"form-group row\">\n                <label for=\"input-domain-vlan-id\" class=\"col-sm-2 col-form-label\">\n                    VLAN ID:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"vlan_id\" type=\"text\" class=\"form-control\" id=\"input-domain-vlan-id\" placeholder=\"1602\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "vlan_id"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id") && runtime.contextOrFrameLookup(context, frame, "ranges") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ranges")),"length") > 0) {
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-domain-name\" class=\"col-sm-2 col-form-label\">\n                    Default Range:\n                </label>\n                <div class=\"col-sm-10\">\n                    <select class=\"form-control\" name=\"default_range\">\n                        ";
output += runtime.suppressValue((lineno = 73, colno = 39, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, ["null","None - deny unknown hosts",null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "default_range")),"id")])), env.opts.autoescape);
output += "\n                        ";
frame = frame.push();
var t_10 = runtime.contextOrFrameLookup(context, frame, "ranges");
if(t_10) {t_10 = runtime.fromIterator(t_10);
var t_9 = t_10.length;
for(var t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8];
frame.set("range", t_11);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += "\n                            ";
output += runtime.suppressValue((lineno = 75, colno = 43, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [runtime.memberLookup((t_11),"id"),runtime.memberLookup((t_11),"name"),null,runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "default_range")),"id")])), env.opts.autoescape);
output += "\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </select>\n                </div>\n            </div>\n            ";
;
}
output += "\n\n            <div class=\"form-group row\">\n                <label class=\"col-sm-2 col-form-label\">\n                    Management features:\n                </label>\n                <div class=\"col-sm-10\">\n                    <div class=\"form-check\">\n                        <label class=\"form-check-label\">\n                            <input class=\"form-check-input\" type=\"checkbox\" name=\"features[]\" value=\"dhcp4\" ";
if(!runtime.contextOrFrameLookup(context, frame, "id") || runtime.inOperator("dhcp4",runtime.contextOrFrameLookup(context, frame, "features"))) {
output += "checked=\"checked\"";
;
}
output += " />\n                            DHCPv4\n                        </label>\n                    </div>\n                    <div class=\"form-check\">\n                        <label class=\"form-check-label\">\n                            <input class=\"form-check-input\" type=\"checkbox\" name=\"features[]\" value=\"dhcp6\" ";
if(!runtime.contextOrFrameLookup(context, frame, "id") || runtime.inOperator("dhcp6",runtime.contextOrFrameLookup(context, frame, "features"))) {
output += "checked=\"checked\"";
;
}
output += " />\n                            DHCPv6\n                        </label>\n                    </div>\n                    <div class=\"form-check\">\n                        <label class=\"form-check-label\">\n                            <input class=\"form-check-input\" type=\"checkbox\" name=\"features[]\" value=\"rad\" ";
if(!runtime.contextOrFrameLookup(context, frame, "id") || runtime.inOperator("rad",runtime.contextOrFrameLookup(context, frame, "features"))) {
output += "checked=\"checked\"";
;
}
output += " />\n                            IPv6 Router Advertisements\n                            <span class=\"text-muted\">\n                            &ndash;\n                            Required for DHCPv6 to work.\n                            </span>\n                        </label>\n                    </div>\n                    <div class=\"form-check\">\n                        <label class=\"form-check-label\">\n                            <input class=\"form-check-input\" type=\"checkbox\" name=\"features[]\" value=\"interface\" ";
if(!runtime.contextOrFrameLookup(context, frame, "id") || runtime.inOperator("interface",runtime.contextOrFrameLookup(context, frame, "features"))) {
output += "checked=\"checked\"";
;
}
output += " />\n                            Managed interface\n                            <span class=\"text-muted\">\n                            &ndash;\n                            Automatically generate the NIC/VLAN device\n                            configuration and keep it up to date. Uncheck if you\n                            need to configure the interface manually.\n                            </span>\n                        </label>\n                    </div>\n                    <div class=\"form-check\">\n                        <label class=\"form-check-label\">\n                            <input class=\"form-check-input\" type=\"checkbox\" name=\"features[]\" value=\"captive_portal\" ";
if(!runtime.contextOrFrameLookup(context, frame, "id") || runtime.inOperator("captive_portal",runtime.contextOrFrameLookup(context, frame, "features"))) {
output += "checked=\"checked\"";
;
}
output += " />\n                            Captive portal\n                            <span class=\"text-muted\">\n                            &ndash;\n                            Block network access from all unregistered hosts.\n                            Redirect all HTTP and HTTPS requests to this portal\n                            for registration.\n                            </span>\n                        </label>\n                    </div>\n                </div>\n            </div>\n\n            <fieldset>\n                <legend>IPv4 Options</legend>\n\n                <div class=\"form-group row\">\n                    <label for=\"input-domain-inet4-address\" class=\"col-sm-2 col-form-label\">\n                        IPv4 network:\n                    </label>\n                    <div class=\"col-sm-10\">\n                        <div class=\"input-group\">\n                            <input aria-label=\"IPv4 network address\" name=\"inet4_address\" type=\"text\" class=\"form-control\" id=\"input-domain-inet4-address\" placeholder=\"172.32.0.0\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inet4_address"), env.opts.autoescape);
output += "\" />\n                            <div class=\"input-group-prepend\">\n                                <span class=\"input-group-text\">/</span>\n                            </div>\n                            <input aria-label=\"IPv4 CIDR prefix length\" name=\"inet4_prefixlen\" type=\"text\" class=\"form-control\" id=\"input-domain-inet4-prefixlen\" placeholder=\"22\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inet4_prefixlen"), env.opts.autoescape);
output += "\" />\n                        </div>\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                        <p class=\"help-block text-muted\">\n                            <strong class=\"text-danger\">Warning!</strong>\n                            Changing this after a network has already been created may have undesired\n                            or unpredictable side effects.\n                        </p>\n                        ";
;
}
output += "\n                    </div>\n                </div>\n\n                <div class=\"form-group row\">\n                    <label for=\"input-domain-inet4-routeraddr\" class=\"col-sm-2 col-form-label\">\n                        IPv4 router IP:\n                    </label>\n                    <div class=\"col-sm-10\">\n                        <input name=\"inet4_routeraddr\" type=\"text\" class=\"form-control\" id=\"input-domain-inet4-routeraddr\" placeholder=\"172.32.0.1\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inet4_routeraddr"), env.opts.autoescape);
output += "\" />\n                    </div>\n                </div>\n\n                <div class=\"form-group row\">\n                    <label for=\"input-domain-inet4-dns\" class=\"col-sm-2 col-form-label\">\n                        IPv4 DNS server:\n                    </label>\n                    <div class=\"col-sm-10\">\n                        <input name=\"dns_server_v4\" type=\"text\" class=\"form-control\" id=\"input-domain-inet4-dns\" placeholder=\"Use default gateway\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "dns_server_v4"), env.opts.autoescape);
output += "\" />\n                        <p class=\"help-block\">\n                            IP address or network interface name on the router. Leave blank to use the default gateway IP.\n                        </p>\n                    </div>\n                </div>\n            </fieldset>\n\n            <fieldset>\n                <legend>IPv6 Options</legend>\n\n                <div class=\"form-group row\">\n                    <label for=\"input-domain-inet6-address\" class=\"col-sm-2 col-form-label\">\n                        IPv6 network:\n                    </label>\n                    <div class=\"col-sm-10\">\n                        <div class=\"input-group\">\n                            <input aria-label=\"IPv6 network address\" name=\"inet6_address\" type=\"text\" class=\"form-control\" id=\"input-domain-inet6-address\" placeholder=\"2600:3f05:c70:1602::\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inet6_address"), env.opts.autoescape);
output += "\" />\n                            <div class=\"input-group-prepend\">\n                                <span class=\"input-group-text\">/</span>\n                            </div>\n                            <input aria-label=\"IPv6 CIDR prefix length\" name=\"inet6_prefixlen\" type=\"text\" class=\"form-control\" id=\"input-domain-inet6-prefixlen\" placeholder=\"64\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inet6_prefixlen"), env.opts.autoescape);
output += "\" />\n                        </div>\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                        <p class=\"help-block text-muted\">\n                            <strong class=\"text-danger\">Warning!</strong>\n                            Changing this after a network has already been created may have undesired\n                            or unpredictable side effects.\n                        </p>\n                        ";
;
}
output += "\n                    </div>\n                </div>\n\n                <div class=\"form-group row\">\n                    <label for=\"input-domain-inet6-routeraddr\" class=\"col-sm-2 col-form-label\">\n                        IPv6 router IP:\n                    </label>\n                    <div class=\"col-sm-10\">\n                        <input name=\"inet6_routeraddr\" type=\"text\" class=\"form-control\" id=\"input-domain-inet6-routeraddr\" placeholder=\"2600:3f05:c70:1602::1\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inet6_routeraddr"), env.opts.autoescape);
output += "\" />\n                    </div>\n                </div>\n\n                <div class=\"form-group row\">\n                    <label for=\"input-domain-inet6-dns\" class=\"col-sm-2 col-form-label\">\n                        IPv6 DNS server:\n                    </label>\n                    <div class=\"col-sm-10\">\n                        <input name=\"dns_server_v6\" type=\"text\" class=\"form-control\" id=\"input-domain-inet6-dns\" placeholder=\"Use default gateway\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "dns_server_v6"), env.opts.autoescape);
output += "\" />\n                        <p class=\"help-block\">\n                            IP address or network interface name on the router. Leave blank to use the default gateway IP.\n                        </p>\n                    </div>\n                </div>\n            </fieldset>\n\n            <fieldset>\n                <legend>PXE Boot Options</legend>\n\n                <div class=\"form-group row\">\n                    <label for=\"input-pxe4-server\" class=\"col-sm-2 col-form-label\">\n                        Boot server IPv4:\n                    </label>\n                    <div class=\"col-sm-10\">\n                        <input name=\"pxe4_server\" type=\"text\" class=\"form-control\" id=\"input-pxe4-server\" placeholder=\"172.32.0.2\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "pxe4_server"), env.opts.autoescape);
output += "\" />\n                    </div>\n                </div>\n\n                <div class=\"form-group row\">\n                    <label for=\"input-pxe6-server\" class=\"col-sm-2 col-form-label\">\n                        Boot server IPv6:\n                    </label>\n                    <div class=\"col-sm-10\">\n                        <input name=\"pxe6_server\" type=\"text\" class=\"form-control\" id=\"input-pxe6-server\" placeholder=\"2600:3f05:c70:1602::2\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "pxe6_server"), env.opts.autoescape);
output += "\" />\n                    </div>\n                </div>\n\n                <div class=\"form-group row\">\n                    <label for=\"input-pxe-filename-bios\" class=\"col-sm-2 col-form-label\">\n                        BIOS boot executable:\n                    </label>\n                    <div class=\"col-sm-10\">\n                        <input name=\"pxe_filename_bios\" type=\"text\" class=\"form-control\" id=\"input-pxe-filename-bios\" placeholder=\"pxelinux.0\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "pxe_filename_bios"), env.opts.autoescape);
output += "\" />\n                    </div>\n                </div>\n\n                <div class=\"form-group row\">\n                    <label for=\"input-pxe-filename-uefi\" class=\"col-sm-2 col-form-label\">\n                        UEFI boot executable:\n                    </label>\n                    <div class=\"col-sm-10\">\n                        <input name=\"pxe_filename_uefi\" type=\"text\" class=\"form-control\" id=\"input-pxe-filename-uefi\" placeholder=\"grub.efi\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "pxe_filename_uefi"), env.opts.autoescape);
output += "\" />\n                    </div>\n                </div>\n            </fieldset>\n\n            <div class=\"form-group row\">\n                <label class=\"col-sm-2 col-form-label\">\n                    Ranges:\n                </label>\n                <div class=\"col-sm-10\">\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "ranges") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ranges")),"length") > 0) {
output += "\n                    <ul class=\"child-link-list\">\n                        ";
frame = frame.push();
var t_14 = runtime.contextOrFrameLookup(context, frame, "ranges");
if(t_14) {t_14 = runtime.fromIterator(t_14);
var t_13 = t_14.length;
for(var t_12=0; t_12 < t_14.length; t_12++) {
var t_15 = t_14[t_12];
frame.set("range", t_15);
frame.set("loop.index", t_12 + 1);
frame.set("loop.index0", t_12);
frame.set("loop.revindex", t_13 - t_12);
frame.set("loop.revindex0", t_13 - t_12 - 1);
frame.set("loop.first", t_12 === 0);
frame.set("loop.last", t_12 === t_13 - 1);
frame.set("loop.length", t_13);
output += "\n                        <li>\n                            <a rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/range/";
output += runtime.suppressValue(runtime.memberLookup((t_15),"id"), env.opts.autoescape);
output += "\">\n                                ";
output += runtime.suppressValue(runtime.memberLookup((t_15),"name"), env.opts.autoescape);
output += "\n\n                                ";
if(runtime.memberLookup((t_15),"inet4_start") && runtime.memberLookup((t_15),"inet4_end")) {
output += "\n                                <span class=\"text-muted\">\n                                &nbsp;&nbsp;&nbsp;&nbsp;\n                                ";
output += runtime.suppressValue(runtime.memberLookup((t_15),"inet4_start"), env.opts.autoescape);
output += "&ndash;";
output += runtime.suppressValue(runtime.memberLookup((t_15),"inet4_end"), env.opts.autoescape);
output += "\n                                </span>\n                                ";
;
}
output += "\n\n                                ";
if(runtime.memberLookup((t_15),"id") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "default_range")),"id")) {
output += "\n                                <span class=\"badge badge-success\">default</span>\n                                ";
;
}
output += "\n                            </a>\n                        </li>\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </ul>\n                    ";
;
}
output += "\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                    <p>\n                        <a rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/range/create\" class=\"btn btn-success\">\n                            <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-plus\"></i>\n                            Add Range\n                        </a>\n                    </p>\n                    ";
;
}
else {
output += "\n                    <p class=\"form-control-static\">Finish creating the domain before adding ranges.</p>\n                    ";
;
}
output += "\n                </div>\n            </div>\n\n            <div class=\"form-group row form-actions\">\n                <div class=\"col-sm-10 offset-sm-2\">\n                    <button type=\"submit\" class=\"btn btn-primary\">\n                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-save\"></i>\n                        Save Domain\n                    </button>\n                </div>\n            </div>\n        </form>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        <div class=\"log-container\" data-thing=\"domain\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\"></div>\n        ";
;
}
output += "\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["host/edit"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("bits/forms", false, "host/edit", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("forms", t_1);
output += "\n<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-desktop\"></i>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        Edit host: ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\n        ";
;
}
else {
output += "\n        Create new host\n        ";
;
}
output += "\n    </h4>\n    <div class=\"col text-right\">\n        <a class=\"btn btn-info btn-cancel-edits\" href=\"hosts\" rel=\"internal\">\n            <i class=\"fas fa-undo-alt\"></i>\n            Return to Host List\n        </a>\n    </div>\n</div>\n<div class=\"row py-3\">\n\t<div class=\"col\">\n        <form name=\"host\" method=\"";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "put";
;
}
else {
output += "post";
;
}
output += "\" data-transport=\"api\" action=\"host";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
;
}
output += "\" class=\"form-horizontal\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-site-id\" class=\"col-sm-2 col-form-label\">\n                    ID:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input readonly=\"readonly\" name=\"id\" type=\"text\" class=\"form-control\" id=\"input-site-id\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            ";
;
}
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-host-name\" class=\"col-sm-2 col-form-label\">\n                    Name:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"name\" type=\"text\" class=\"form-control\" id=\"input-host-name\" placeholder=\"ncc1701\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            <div class=\"form-group row\">\n                <label for=\"input-host-description\" class=\"col-sm-2 col-form-label\">\n                    Description:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"description\" type=\"text\" class=\"form-control\" id=\"input-host-description\" placeholder=\"Starship &quot;Enterprise&quot; NCC-1701-D\" value=\"";
if(runtime.contextOrFrameLookup(context, frame, "description")) {
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "description"), env.opts.autoescape);
;
}
output += "\" />\n                </div>\n            </div>\n            <div class=\"form-group row\">\n                <label for=\"input-host-role\" class=\"col-sm-2 col-form-label\">\n                    Type:\n                </label>\n                <div class=\"col-sm-10\">\n                    <select name=\"role\" id=\"input-host-role\" class=\"form-control\">\n                        ";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "hosttypes");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_4;
if(runtime.isArray(t_6)) {
var t_5 = t_6.length;
for(t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4][0];
frame.set("[object Object]", t_6[t_4][0]);
var t_8 = t_6[t_4][1];
frame.set("[object Object]", t_6[t_4][1]);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n                            ";
output += runtime.suppressValue((lineno = 53, colno = 42, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_7,t_7,runtime.memberLookup((t_8),"icon"),runtime.contextOrFrameLookup(context, frame, "role")])), env.opts.autoescape);
output += "\n                        ";
;
}
} else {
t_4 = -1;
var t_5 = runtime.keys(t_6).length;
for(var t_9 in t_6) {
t_4++;
var t_10 = t_6[t_9];
frame.set("type", t_9);
frame.set("meta", t_10);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n                            ";
output += runtime.suppressValue((lineno = 53, colno = 42, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_9,t_9,runtime.memberLookup((t_10),"icon"),runtime.contextOrFrameLookup(context, frame, "role")])), env.opts.autoescape);
output += "\n                        ";
;
}
}
}
frame = frame.pop();
output += "\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group row\">\n                <label for=\"input-host-os\" class=\"col-sm-2 col-form-label\">\n                    OS:\n                </label>\n                <div class=\"col-sm-10\">\n                    <select name=\"os\" id=\"input-host-os\" class=\"form-control\">\n                        ";
frame = frame.push();
var t_13 = runtime.contextOrFrameLookup(context, frame, "oses");
if(t_13) {t_13 = runtime.fromIterator(t_13);
var t_11;
if(runtime.isArray(t_13)) {
var t_12 = t_13.length;
for(t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11][0];
frame.set("[object Object]", t_13[t_11][0]);
var t_15 = t_13[t_11][1];
frame.set("[object Object]", t_13[t_11][1]);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "\n                            ";
output += runtime.suppressValue((lineno = 65, colno = 42, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_14,t_14,runtime.memberLookup((t_15),"icon") + " fab",runtime.contextOrFrameLookup(context, frame, "os")])), env.opts.autoescape);
output += "\n                        ";
;
}
} else {
t_11 = -1;
var t_12 = runtime.keys(t_13).length;
for(var t_16 in t_13) {
t_11++;
var t_17 = t_13[t_16];
frame.set("osname", t_16);
frame.set("meta", t_17);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "\n                            ";
output += runtime.suppressValue((lineno = 65, colno = 42, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_16,t_16,runtime.memberLookup((t_17),"icon") + " fab",runtime.contextOrFrameLookup(context, frame, "os")])), env.opts.autoescape);
output += "\n                        ";
;
}
}
}
frame = frame.pop();
output += "\n                    </select>\n                </div>\n            </div>\n\n            ";
if((lineno = 71, colno = 48, runtime.callWrap(runtime.memberLookup((["Apple iOS","macOS"]),"indexOf"), "--expression--[\"indexOf\"]", context, [runtime.contextOrFrameLookup(context, frame, "os")])) > -1) {
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-host-os\" class=\"col-sm-2 col-form-label\">\n                    Mobile Device Management:\n                </label>\n                <div class=\"col-sm-10\">\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm")),"enrollment_status")),"enrolled")) {
output += "\n                    <p class=\"form-control-static\">\n                        <span class=\"badge badge-success\">Enrolled</span>\n                    </p>\n                    <table class=\"table table-bordered table-striped\">\n                        <tbody>\n                            <tr>\n                                <td>Enrolled:</td>\n                                <td><span class=\"timeago\" data-timestamp=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm")),"enrollment_status")),"enrolled_time"), env.opts.autoescape);
output += "\">Loading &hellip;</span></td>\n                            </tr>\n                            <tr>\n                                <td>Device model:</td>\n                                <td>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm")),"apple_device_info")),"ProductName"), env.opts.autoescape);
output += "</td>\n                            </tr>\n                            <tr>\n                                <td>";
if((lineno = 92, colno = 61, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm")),"ios_regexp")),"test"), "mdm[\"ios_regexp\"][\"test\"]", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm")),"apple_device_info")),"ProductName")]))) {
output += "iOS";
;
}
else {
output += "macOS";
;
}
output += " version:</td>\n                                <td>\n                                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm")),"apple_device_info")),"OSVersion"), env.opts.autoescape);
output += "\n                                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm")),"apple_device_info")),"BuildVersion")) {
output += "\n                                    <span class=\"text-muted\">(Build ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm")),"apple_device_info")),"BuildVersion"), env.opts.autoescape);
output += ")</span>\n                                    ";
;
}
output += "\n                                </td>\n                            </tr>\n                            <tr>\n                                <td>Hardware serial number:</td>\n                                <td>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm")),"apple_device_info")),"SerialNumber"), env.opts.autoescape);
output += "</td>\n                            </tr>\n                            <tr>\n                                <td>UDID:</td>\n                                <td>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "mdm")),"apple_device_info")),"UDID"), env.opts.autoescape);
output += "</td>\n                            </tr>\n                        </tbody>\n                    </table>\n                    <div class=\"form-control-static dropdown\">\n                        <a class=\"btn btn-primary\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm\">\n                            <i class=\"fas fa-terminal\"></i>\n                            Commands\n                        </a>\n                        <div class=\"dropdown-menu\">\n                            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=repush&amp;p=mainline\">Push System Profile</a>\n                            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=repush&amp;p=attest\">Push Enrollment Profile</a>\n                            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=repush&amp;p=user\">Push User Profile</a>\n                            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=list-profiles\">List Installed Profiles</a>\n                            <div class=\"dropdown-divider\"></div>\n                            <a class=\"dropdown-item text-danger\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=lock\">Lock Device</a>\n                        </div>\n                        <a class=\"btn btn-danger\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/unenroll\">Unenroll</a>\n                    </div>\n                    ";
;
}
else {
output += "\n                    <p class=\"form-control-static\">\n                        <a class=\"btn btn-primary\" href=\"api/host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/enroll\">Enroll</a>\n                    </p>\n                    ";
;
}
output += "\n                </div>\n            </div>\n            ";
;
}
output += "\n\n            <div class=\"form-group row\">\n                <label for=\"input-host-owner\" class=\"col-sm-2 col-form-label\">\n                    Owner:\n                </label>\n                <div class=\"col-sm-10\">\n                    <select ";
if(!runtime.contextOrFrameLookup(context, frame, "id") && !runtime.inOperator("host.admin",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"abilities")) && !runtime.inOperator("superadmin",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"abilities"))) {
output += "readonly=\"readonly\"";
;
}
output += "\n                            name=\"owner\" class=\"form-control\" id=\"input-host-owner\">\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                        <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "owner")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "owner")),"principal"), env.opts.autoescape);
output += "</option>\n                        ";
;
}
else {
output += "\n                        <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"identity"), env.opts.autoescape);
output += "</option>\n                        ";
;
}
output += "\n                    </select>\n                </div>\n            </div>\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n            <div class=\"form-group row\">\n                <label for=\"lbl-host-last-seen\" class=\"col-sm-2 col-form-label\">\n                    Created:\n                </label>\n                <div class=\"col-sm-10\">\n                    <p class=\"form-control-static\">\n                        <span class=\"timeago\" data-timestamp=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "created_at"), env.opts.autoescape);
output += "\"><span class=\"text-muted\">Loading...</span></span>\n                    </p>\n                </div>\n            </div>\n            <div class=\"form-group row\">\n                <label for=\"lbl-host-last-seen\" class=\"col-sm-2 col-form-label\">\n                    Last Seen:\n                </label>\n                <div class=\"col-sm-10\">\n                    <p class=\"form-control-static\">\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "last_seen")) {
output += "\n                        <span class=\"timeago host-last-seen\" data-timestamp=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "last_seen"), env.opts.autoescape);
output += "\"><span class=\"text-muted\">Loading...</span></span>\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "last_seen_iface")) {
output += "\n                            <br />\n                            Interface\n                                <strong>\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iftypes")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "last_seen_iface")),"type"))),"icon"), env.opts.autoescape);
output += " last-iface-type\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iftypes")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "last_seen_iface")),"type"))),"label"), env.opts.autoescape);
output += "\"></i>\n                                <span class=\"last-iface-name\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "last_seen_iface")),"name"), env.opts.autoescape);
output += "</span>\n                                </strong>\n                            from\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "last_seen_iface")),"last_inet4")) {
output += "\n                                IPv4 address <tt class=\"last-inet4\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "last_seen_iface")),"last_inet4"), env.opts.autoescape);
output += "</tt>\n                                ";
;
}
output += "\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "last_seen_iface")),"last_inet4") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "last_seen_iface")),"last_inet6")) {
output += "\n                                and\n                            ";
;
}
output += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "last_seen_iface")),"last_inet6")) {
output += "\n                                IPv6 address <tt class=\"last-inet6\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "last_seen_iface")),"last_inet6"), env.opts.autoescape);
output += "</tt>\n                                ";
;
}
output += "\n                            ";
;
}
output += "\n                        ";
;
}
else {
output += "\n                        Never\n                        ";
;
}
output += "\n                    </p>\n                </div>\n            </div>\n            ";
;
}
output += "\n\n            <div class=\"form-group row\">\n                <label class=\"col-sm-2 col-form-label\">\n                    Options:\n                </label>\n                <div class=\"col-sm-10\">\n                    <div class=\"form-check\">\n                        <label class=\"form-check-label\">\n                            <input class=\"form-check-input\" type=\"checkbox\"\n                                    name=\"flags[]\" value=\"disabled\"\n                                    ";
if(runtime.contextOrFrameLookup(context, frame, "id") && runtime.inOperator("disabled",runtime.contextOrFrameLookup(context, frame, "flags"))) {
output += "checked=\"checked\"";
;
}
output += "\n                                    ";
if(!runtime.inOperator("host.admin",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"abilities")) && !runtime.inOperator("superadmin",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"abilities"))) {
output += "\n                                    disabled=\"disabled\"\n                                    ";
;
}
output += "\n                                    />\n                            <strong>Quarantine</strong>\n                            <span class=\"text-muted\">\n                            &ndash;\n                            Blocks all network access by the host on domains\n                            with captive portal enabled\n                            </span>\n                        </label>\n                        <label class=\"form-check-label\">\n                            <input class=\"form-check-input\" type=\"checkbox\"\n                                    name=\"flags[]\" value=\"sticky\"\n                                    ";
if(runtime.contextOrFrameLookup(context, frame, "id") && runtime.inOperator("sticky",runtime.contextOrFrameLookup(context, frame, "flags"))) {
output += "checked=\"checked\"";
;
}
output += "\n                                    ";
if(!runtime.inOperator("host.admin",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"abilities")) && !runtime.inOperator("superadmin",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"abilities"))) {
output += "\n                                    disabled=\"disabled\"\n                                    ";
;
}
output += "\n                                    />\n                            <strong>Sticky</strong>\n                            <span class=\"text-muted\">\n                            &ndash;\n                            This host will always be published in DNS, even if it hasn't been seen.\n                            </span>\n                        </label>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"form-group row\">\n                <label class=\"col-sm-2 col-form-label\">\n                    Interfaces:\n                </label>\n                <div class=\"col-sm-10\">\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "interfaces") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "interfaces")),"length") > 0) {
output += "\n                    <ul class=\"child-link-list\">\n                        ";
frame = frame.push();
var t_20 = runtime.contextOrFrameLookup(context, frame, "interfaces");
if(t_20) {t_20 = runtime.fromIterator(t_20);
var t_19 = t_20.length;
for(var t_18=0; t_18 < t_20.length; t_18++) {
var t_21 = t_20[t_18];
frame.set("iface", t_21);
frame.set("loop.index", t_18 + 1);
frame.set("loop.index0", t_18);
frame.set("loop.revindex", t_19 - t_18);
frame.set("loop.revindex0", t_19 - t_18 - 1);
frame.set("loop.first", t_18 === 0);
frame.set("loop.last", t_18 === t_19 - 1);
frame.set("loop.length", t_19);
output += "\n                        <li>\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/interface/";
output += runtime.suppressValue(runtime.memberLookup((t_21),"id"), env.opts.autoescape);
output += "\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iftypes")),runtime.memberLookup((t_21),"type"))),"icon"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iftypes")),runtime.memberLookup((t_21),"type"))),"label"), env.opts.autoescape);
output += "\"></i>\n                                ";
output += runtime.suppressValue(runtime.memberLookup((t_21),"name"), env.opts.autoescape);
output += "\n\n                                <span class=\"hardware-address text-muted\">\n                                    ";
output += runtime.suppressValue(runtime.memberLookup((t_21),"hardware_address"), env.opts.autoescape);
output += "\n                                </span>\n                            </a>\n                        </li>\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </ul>\n                    ";
;
}
output += "\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                    <p>\n                        <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/interface/create\" class=\"btn btn-success\">\n                            <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-plus\"></i>\n                            Add Interface\n                        </a>\n                    </p>\n                    ";
;
}
else {
output += "\n                    <p class=\"form-control-static\">Finish creating the host before adding an interface.</p>\n                    ";
;
}
output += "\n                </div>\n            </div>\n\n            <div class=\"form-group row\">\n                <label class=\"col-sm-2 col-form-label\">\n                    Trusted Computing:\n                </label>\n                <div class=\"col-sm-10\">\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"found")) {
output += "\n                        <p class=\"form-control-static\">\n                            <span class=\"badge badge-success\">Supported</span><br />\n                            Endorsement key is on file.\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/tpm-reset\" class=\"text-danger\">\n                                Forget TPM keys...\n                            </a>\n                        </p>\n\n                        <p class=\"help-block\">\n                            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"type") == "CERTIFICATE") {
output += "\n                            <i class=\"fa fa-certificate\"></i> Type: X.509 Certificate\n                                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"x509")),"subject")) {
output += "\n                                    <br />\n                                    <i class=\"fa fa-microchip\"></i>\n                                    Subject: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"x509")),"subject"), env.opts.autoescape);
output += "\n                                ";
;
}
output += "\n                                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"x509")),"issuer")) {
output += "\n                                    <br />\n                                    <i class=\"fa fa-building\"></i>\n                                    Issuer: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"x509")),"issuer"), env.opts.autoescape);
output += "\n                                ";
;
}
output += "\n                                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"x509")),"serial")) {
output += "\n                                    <br />\n                                    <i class=\"fas fa-tag\"></i>\n                                    Serial number: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"x509")),"serial"), env.opts.autoescape);
output += "\n                                ";
;
}
output += "\n                            ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"type") == "RSA PUBLIC KEY") {
output += "\n                            <i class=\"fa fa-key\"></i> Type: RSA key\n                            ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"type") == "EC PUBLIC KEY") {
output += "\n                            <i class=\"fa fa-key\"></i> Type: Elliptic-Curve DSA key\n                            ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"type") == "PUBLIC KEY") {
output += "\n                            <i class=\"fa fa-key\"></i> Type: PKIX key\n                            ";
;
}
;
}
;
}
;
}
output += "<br />\n                            <i class=\"fa fa-fingerprint\"></i> <span class=\"badge badge-warning\">SHA-1</span> <tt>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"fingerprint")),"sha1"), env.opts.autoescape);
output += "</tt><br />\n                            <i class=\"fa fa-fingerprint\"></i> <span class=\"badge badge-success\">SHA-256</span> <tt>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "endorsement_key")),"endorsement_key")),"fingerprint")),"sha256"), env.opts.autoescape);
output += "</tt><br />\n                        </p>\n                    ";
;
}
else {
output += "\n                        <p class=\"form-control-static\">\n                            <span class=\"badge badge-secondary\">Not supported</span>\n                        </p>\n                    ";
;
}
output += "\n                </div>\n            </div>\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n            <div class=\"tag-container\" data-thing=\"host\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\"></div>\n            ";
;
}
output += "\n\n            <div class=\"form-group row form-actions\">\n                <div class=\"col-sm-10 offset-sm-2\">\n                    <button type=\"submit\" class=\"btn btn-primary\">\n                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-save\"></i>\n                        Save Host\n                    </button>\n                </div>\n            </div>\n        </form>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        <div class=\"log-container\" data-thing=\"host\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\"></div>\n        ";
;
}
output += "\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["host/mdm/command-result"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<table class=\"table table-bordered table-striped\">\n    <tbody>\n        <tr>\n            <td>Command ID</td>\n            <td>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cmd")),"id"), env.opts.autoescape);
output += "</td>\n        </tr>\n        <tr>\n            <td>Creation time</td>\n            <td><span class=\"timestamp\" data-timestamp=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cmd")),"created_at"), env.opts.autoescape);
output += "\"></span></td>\n        </tr>\n        <tr>\n            <td>Last status change</td>\n            <td><span class=\"timestamp\" data-timestamp=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cmd")),"updated_at"), env.opts.autoescape);
output += "\"></span></td>\n        </tr>\n        <tr>\n            <td>Finished time</td>\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cmd")),"finished_at")) {
output += "\n                <td><span class=\"timestamp\" data-timestamp=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cmd")),"finished_at"), env.opts.autoescape);
output += "\"></span></td>\n            ";
;
}
else {
output += "\n                <td><em class=\"text-muted\">Not finished yet</em></td>\n            ";
;
}
output += "\n        </tr>\n        <tr>\n            <td>Arguments</td>\n            <td><pre>";
output += runtime.suppressValue((lineno = 24, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "json_encode"), "json_encode", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cmd")),"args")])), env.opts.autoescape);
output += "</pre></td>\n        </tr>\n        <tr>\n            <td>Result</td>\n            <td><pre>";
output += runtime.suppressValue((lineno = 28, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "json_encode"), "json_encode", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cmd")),"result")])), env.opts.autoescape);
output += "</pre></td>\n        </tr>\n    </tbody>\n</table>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["host/mdm/commands"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-terminal\"></i>\n        MDM commands for host <span class=\"hostname\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "</span>\n    </h4>\n    <div class=\"col text-right\">\n        <a class=\"btn btn-primary btn-mdm-run-command dropdown-toggle\" data-loading-text=\"Running MDM Command&hellip;\" data-toggle=\"dropdown\" aria-expanded=\"false\">\n            Run MDM Command\n        </a>\n        <div class=\"dropdown-menu\">\n            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=repush&amp;p=mainline\">Push System Profile</a>\n            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=repush&amp;p=enroll\">Push Enrollment Profile</a>\n            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=repush&amp;p=user\">Push User Profile</a>\n            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=list-profiles\">List Installed Profiles</a>\n            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=list-users\">List Users</a>\n            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=list-certificates\">List Certificates</a>\n            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=enable-remote\">Enable Remote Desktop</a>\n            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=disable-remote\">Disable Remote Desktop</a>\n            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=lock-bypass\">Get Activation Lock bypass code</a>\n            <a class=\"dropdown-item\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=create-admin\">Create xx0r-admin user</a>\n            <div class=\"dropdown-divider\"></div>\n            <a class=\"dropdown-item text-danger\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=lock\">Lock Device</a>\n            <a class=\"dropdown-item text-danger\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=shutdown\">Shut Down Device</a>\n            <a class=\"dropdown-item text-danger\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/mdm/command?a=eacs\">Remote Wipe Device</a>\n        </div>\n        <a class=\"btn btn-info btn-cancel-edits\" href=\"host/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" rel=\"internal\">\n            <i class=\"fas fa-undo-alt\"></i>\n            Return to Host: ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\n        </a>\n    </div>\n</div>\n<div class=\"row\">\n\t<div class=\"col\">\n\t\t<table class=\"table table-bordered table-striped table-mdm-commands\">\n\t\t\t<thead>\n\t\t\t\t<th>Command</th>\n\t\t\t\t<th>Status</th>\n                <th>Last Updated</th>\n                <th>Actions</th>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n</div>\n\n<div class=\"modal hide fade\" id=\"modal-command-details\">\n    <div class=\"modal-dialog modal-xl\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\">Command Result</h5>\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n            </div>\n            <div class=\"modal-body\"></div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\">\n                    <i class=\"fas fa-times\"></i>\n                    Close\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["host/unregistered"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("bits/forms", false, "host/unregistered", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("forms", t_1);
output += "\n<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-lock\"></i>\n        Host Registration\n    </h4>\n\n</div>\n<div class=\"row py-3\">\n\t<div class=\"col\">\n        <form method=\"post\" data-transport=\"api\" action=\"whoami/autoregister\" class=\"form-horizontal\">\n            ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"registered")) {
output += "\n            <div class=\"alert alert-info\">\n                <strong>This system isn't registered on the network.</strong> You must register it to receive network access.\n            </div>\n            ";
;
}
output += "\n\n            <fieldset>\n                ";
var t_4;
t_4 = false;
frame.set("quarantined", t_4, true);
if(frame.topLevel) {
context.setVariable("quarantined", t_4);
}
if(frame.topLevel) {
context.addExport("quarantined", t_4);
}
output += "\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"iface")) {
output += "\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"host") && runtime.inOperator("disabled",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"host")),"flags"))) {
output += "\n                        ";
var t_5;
t_5 = true;
frame.set("quarantined", t_5, true);
if(frame.topLevel) {
context.setVariable("quarantined", t_5);
}
if(frame.topLevel) {
context.addExport("quarantined", t_5);
}
output += "\n                    ";
;
}
output += "\n                ";
;
}
output += "\n\n                ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"identity") && !runtime.contextOrFrameLookup(context, frame, "quarantined")) {
output += "\n                    <legend>Log in to register your device</legend>\n\n                    <p>This network requires all devices to be registered before using the network. Device registration\n                        facilitates asset tracking, DNS, security policies and static IP addresses.</p>\n\n                    <p>Please log in using the button below, then you will be brought back to this page to complete\n                        device registration.</p>\n\n                    <p>\n                        <a class=\"btn btn-primary\" rel=\"redirect-to-login\">\n                            <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-sign-in\"></i>\n                            Sign in\n                        </a>\n                        <a class=\"btn btn-default\" rel=\"guest-login\">\n                            <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-user\"></i>\n                            Continue as guest\n                        </a>\n                    </p>\n                ";
;
}
output += "\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"iface") || runtime.contextOrFrameLookup(context, frame, "quarantined")) {
output += "\n                    <legend>Your machine's detected information</legend>\n                    <div class=\"form-group row\">\n                        <label for=\"input-urh-ip\" class=\"col-sm-2 col-form-label\">\n                            IP address:\n                        </label>\n                        <div class=\"col-sm-10\">\n                            <p class=\"form-control-static\">\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"ip"), env.opts.autoescape);
output += "\n                                <input type=\"hidden\" name=\"ip\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"ip"), env.opts.autoescape);
output += "\" />\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label for=\"input-urh-mac\" class=\"col-sm-2 col-form-label\">\n                            MAC address:\n                        </label>\n                        <div class=\"col-sm-10\">\n                            <p class=\"form-control-static\">\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"iface")),"hardware_address"), env.opts.autoescape);
output += "\n                                <input type=\"hidden\" name=\"hardware_address\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"iface")),"hardware_address"), env.opts.autoescape);
output += "\" />\n                            </p>\n                        </div>\n                    </div>\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "quarantined")) {
output += "\n                        <div class=\"alert alert-danger\">\n                            <strong>This host has been quarantined.</strong> You\n                            will not be able to access network resources from\n                            this machine. Please contact your administrator for\n                            assistance.\n                        </div>\n                    ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"identity")) {
output += "\n                        <div class=\"form-group row\">\n                            <label for=\"input-urh-ip\" class=\"col-sm-2 col-form-label\">\n                                Desired hostname:\n                            </label>\n                            <div class=\"col-sm-10\">\n                                <input class=\"form-control\" type=\"text\"\n                                    ";
if(runtime.contextOrFrameLookup(context, frame, "suggested_hostname")) {
output += "\n                                    value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "suggested_hostname"), env.opts.autoescape);
output += "\"\n                                    ";
;
}
output += "\n                                    pattern=\"^[A-Za-z0-9\\-]{3,}$\"\n                                    name=\"name\" placeholder=\"ncc1701d\" />\n                                <p class=\"help-block\">\n                                    May contain uppercase and lowercase letters, numbers and dashes. No spaces or special characters are permitted.\n                                </p>\n                            </div>\n                        </div>\n                    ";
;
}
;
}
output += "\n                ";
;
}
else {
output += "\n                <p>We couldn't find your system (";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"ip"), env.opts.autoescape);
output += ") on the network.\n                    This means you'll need to input your system's information\n                    yourself in order to register it.</p>\n                ";
;
}
output += "\n            </fieldset>\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "identity")),"identity") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "whoami")),"iface") && !runtime.contextOrFrameLookup(context, frame, "quarantined")) {
output += "\n            <div class=\"form-group row form-actions\">\n                <div class=\"col-sm-10 offset-sm-2\">\n                    <button type=\"submit\" class=\"btn btn-success\">\n                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-check\"></i>\n                        Complete Registration\n                    </button>\n                </div>\n            </div>\n            ";
;
}
output += "\n        </form>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["interface/edit"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("bits/forms", false, "interface/edit", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("forms", t_1);
output += "\n<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-desktop\"></i>\n        <a href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"id"), env.opts.autoescape);
output += "\" rel=\"internal\">Edit host: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"name"), env.opts.autoescape);
output += "</a>\n        &raquo;\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        Edit interface: ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\n        ";
;
}
else {
output += "\n        Create interface\n        ";
;
}
output += "\n    </h4>\n    <div class=\"col text-right\">\n        <a class=\"btn btn-info btn-cancel-edits\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"id"), env.opts.autoescape);
output += "\" rel=\"internal\">\n            <i class=\"fas fa-undo-alt\"></i>\n            Return to Host: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"name"), env.opts.autoescape);
output += "\n        </a>\n    </div>\n</div>\n<div class=\"row py-3\">\n\t<div class=\"col\">\n\n        <form name=\"interface\" method=\"";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "put";
;
}
else {
output += "post";
;
}
output += "\" data-transport=\"api\" action=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"id"), env.opts.autoescape);
output += "/interface";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
;
}
output += "\" class=\"form-horizontal\">\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-interface-id\" class=\"col-sm-2 col-form-label\">\n                    ID:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input readonly=\"readonly\" name=\"id\" type=\"text\" class=\"form-control\" id=\"input-interface-id\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            ";
;
}
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-interface-name\" class=\"col-sm-2 col-form-label\">\n                    Name:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"name\" type=\"text\" class=\"form-control\" id=\"input-interface-name\" placeholder=\"eth0\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            <div class=\"form-group row\">\n                <label for=\"input-interface-hardware-address\" class=\"col-sm-2 col-form-label\">\n                    MAC address:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"hardware_address\" type=\"text\" class=\"form-control\" id=\"input-interface-hardware-address\" placeholder=\"00:ca:13:ab:d1:97\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "hardware_address"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            <div class=\"form-group row\">\n                <label for=\"input-interface-type\" class=\"col-sm-2 col-form-label\">\n                    Type:\n                </label>\n                <div class=\"col-sm-10\">\n                    <select name=\"type\" class=\"form-control\">\n                        ";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "iftypes");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_4;
if(runtime.isArray(t_6)) {
var t_5 = t_6.length;
for(t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4][0];
frame.set("[object Object]", t_6[t_4][0]);
var t_8 = t_6[t_4][1];
frame.set("[object Object]", t_6[t_4][1]);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n                            ";
output += runtime.suppressValue((lineno = 57, colno = 43, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_7,runtime.memberLookup((t_8),"label"),runtime.memberLookup((t_8),"icon"),runtime.contextOrFrameLookup(context, frame, "type")])), env.opts.autoescape);
output += "\n                        ";
;
}
} else {
t_4 = -1;
var t_5 = runtime.keys(t_6).length;
for(var t_9 in t_6) {
t_4++;
var t_10 = t_6[t_9];
frame.set("id", t_9);
frame.set("meta", t_10);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n                            ";
output += runtime.suppressValue((lineno = 57, colno = 43, runtime.callWrap(runtime.memberLookup((t_1),"option"), "forms[\"option\"]", context, [t_9,runtime.memberLookup((t_10),"label"),runtime.memberLookup((t_10),"icon"),runtime.contextOrFrameLookup(context, frame, "type")])), env.opts.autoescape);
output += "\n                        ";
;
}
}
}
frame = frame.pop();
output += "\n                    </select>\n                </div>\n            </div>\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "unclaimed")) {
output += "\n            <div class=\"form-group row\">\n                <label class=\"col-sm-2 col-form-label\">\n                    Claim an interface:\n                </label>\n                <div class=\"col-sm-10\">\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "unclaimed")),"length") > 0) {
output += "\n                    <ul class=\"child-link-list\">\n                        ";
frame = frame.push();
var t_13 = runtime.contextOrFrameLookup(context, frame, "unclaimed");
if(t_13) {t_13 = runtime.fromIterator(t_13);
var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("ucif", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "\n                        <li>\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"id"), env.opts.autoescape);
output += "/interface/claim/";
output += runtime.suppressValue(runtime.memberLookup((t_14),"id"), env.opts.autoescape);
output += "\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iftypes")),runtime.memberLookup((t_14),"type"))),"icon"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iftypes")),runtime.memberLookup((t_14),"type"))),"label"), env.opts.autoescape);
output += "\"></i>\n                                ";
output += runtime.suppressValue(runtime.memberLookup((t_14),"hardware_address"), env.opts.autoescape);
output += "\n\n                                <span class=\"hardware-address text-muted\">\n                                    ";
if(runtime.memberLookup((t_14),"last_inet4")) {
output += "\n                                        ";
output += runtime.suppressValue(runtime.memberLookup((t_14),"last_inet4"), env.opts.autoescape);
output += "\n                                    ";
;
}
else {
if(runtime.memberLookup((t_14),"last_inet6")) {
output += "\n                                        ";
output += runtime.suppressValue(runtime.memberLookup((t_14),"last_inet6"), env.opts.autoescape);
output += "\n                                    ";
;
}
;
}
output += "\n                                </span>\n\n                                ";
if(runtime.memberLookup((t_14),"last_seen") > 0) {
output += "\n                                <span class=\"last-seen text-muted\">\n                                    <span class=\"timeago only\" data-timestamp=\"";
output += runtime.suppressValue(runtime.memberLookup((t_14),"last_seen"), env.opts.autoescape);
output += "\">\n                                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-clock\"></i>\n                                    </span>\n                                </span>\n                                ";
;
}
else {
output += "\n                                <span class=\"last-seen text-muted\">\n                                    Never seen\n                                </span>\n                                ";
;
}
output += "\n                            </a>\n                        </li>\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </ul>\n                    ";
;
}
else {
output += "\n                    <p class=\"form-control-static\">No unclaimed interfaces found.</p>\n                    ";
;
}
output += "\n                </div>\n            </div>\n            ";
;
}
output += "\n\n            <fieldset>\n                <legend class=\"pull-left\">\n                    Reservations\n                </legend>\n                ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                <div class=\"pull-right\">\n                    <a class=\"btn btn-success btn-create-reservation\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"id"), env.opts.autoescape);
output += "/interface/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/reservation/create\">\n                        <i class=\"fas fa-plus\"></i>\n                        Create Reservation\n                    </a>\n                </div>\n                <div class=\"clearfix\"></div>\n                <table class=\"table table-bordered table-striped\">\n                    <thead>\n                        <th>Domain</th>\n                        <th>Range</th>\n                        <th>Address type</th>\n                        <th>Reserved Address</th>\n                        <th class=\"actions\"><i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-cog\"></i></th>\n                    </thead>\n                    <tbody>\n                        ";
frame = frame.push();
var t_17 = runtime.contextOrFrameLookup(context, frame, "reservations");
if(t_17) {t_17 = runtime.fromIterator(t_17);
var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("res", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\n                        <tr>\n                            <td>\n                                ";
if(runtime.memberLookup((t_18),"domain")) {
output += "\n                                    <a rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"domain")),"id"), env.opts.autoescape);
output += "\">\n                                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"domain")),"name"), env.opts.autoescape);
output += "\n                                    </a>\n                                ";
;
}
else {
output += "\n                                    <em>Domain not found</em>\n                                ";
;
}
output += "\n                            </td>\n                            <td>\n                                ";
if(runtime.memberLookup((t_18),"range")) {
output += "\n                                    <a rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"domain")),"id"), env.opts.autoescape);
output += "/range/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"range")),"id"), env.opts.autoescape);
output += "\">\n                                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"range")),"name"), env.opts.autoescape);
output += "\n                                    </a>\n                                ";
;
}
else {
output += "\n                                    <em>Not in any range</em>\n                                ";
;
}
output += "\n                            </td>\n                            <td>";
if(runtime.memberLookup((t_18),"af") == "inet") {
output += "IPv4";
;
}
else {
if(runtime.memberLookup((t_18),"af") == "inet6") {
output += "IPv6";
;
}
else {
output += runtime.suppressValue(runtime.memberLookup((t_18),"af"), env.opts.autoescape);
;
}
;
}
output += "</td>\n                            <td>";
output += runtime.suppressValue(runtime.memberLookup((t_18),"address"), env.opts.autoescape);
output += "</td>\n                            <td class=\"actions\">\n                                <a class=\"btn btn-sm btn-danger\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"id"), env.opts.autoescape);
output += "/interface/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/reservation/";
output += runtime.suppressValue(runtime.memberLookup((t_18),"id"), env.opts.autoescape);
output += "/delete\" title=\"Delete Reservation\">\n                                    <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-trash\"></i>\n                                </a>\n                            </td>\n                        </tr>\n                        ";
;
}
}
if (!t_16) {
output += "\n                        <tr>\n                            <td colspan=\"5\">\n                                No reservations.\n                            </td>\n                        </tr>\n                        ";
}
frame = frame.pop();
output += "\n                    </tbody>\n                </table>\n                ";
;
}
else {
output += "\n                <div class=\"clearfix\"></div>\n                <p>Finish creating the interface before adding reservations.</p>\n                ";
;
}
output += "\n            </fieldset>\n            <div class=\"form-group row form-actions\">\n                <div class=\"col-sm-10 offset-sm-2\">\n                    <button type=\"submit\" class=\"btn btn-primary\">\n                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-save\"></i>\n                        Save Interface\n                    </button>\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                    <a class=\"btn btn-danger\" rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "host")),"id"), env.opts.autoescape);
output += "/interface/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/delete\">\n                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-trash\"></i>\n                        Delete Interface\n                    </a>\n                    ";
;
}
output += "\n                </div>\n            </div>\n        </form>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        <div class=\"log-container\" data-thing=\"iface\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\"></div>\n        ";
;
}
output += "\n    </div>\n</div>\n\n<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"modal-create-reservation\">\n\t<div class=\"modal-dialog modal-lg\" role=\"document\">\n\t\t<div class=\"modal-content\">\n\t\t\t<form method=\"post\" data-transport=\"api\" action=\"interface/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/reservation\" class=\"form-horizontal\">\n\t\t\t\t<div class=\"modal-header\">\n\t\t\t\t\t<h5 class=\"modal-title\">Add Reservation for <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iftypes")),runtime.contextOrFrameLookup(context, frame, "type"))),"icon"), env.opts.autoescape);
output += "\"></i> ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "</h5>\n\t\t\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n\t\t\t\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-body\">\n\t\t\t\t\t<div class=\"form-group row\">\n\t\t\t\t\t\t<label class=\"col-sm-2 col-form-label\">\n\t\t\t\t\t\t\tAddress type:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<div class=\"col-sm-10\">\n\t\t\t\t\t\t\t<div class=\"form-check form-check-inline\">\n\t\t\t\t\t\t\t    <label class=\"form-check-label\">\n\t\t\t\t\t\t\t        <input class=\"form-check-input\" type=\"radio\" name=\"af\" value=\"inet\" checked=\"checked\" />\n\t\t\t\t\t\t\t        IPv4\n\t\t\t\t\t\t\t    </label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"form-check form-check-inline\">\n\t\t\t\t\t\t\t    <label class=\"form-check-label\">\n\t\t\t\t\t\t\t        <input class=\"form-check-input\" type=\"radio\" name=\"af\" value=\"inet6\" />\n\t\t\t\t\t\t\t        IPv6\n\t\t\t\t\t\t\t    </label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group row\">\n\t\t\t\t\t\t<label class=\"col-sm-2 col-form-label\">\n\t\t\t\t\t\t\tAllocation strategy:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<div class=\"col-sm-10\">\n\t\t\t\t\t\t\t<div class=\"form-check form-check-inline\">\n\t\t\t\t\t\t\t    <label class=\"form-check-label\">\n\t\t\t\t\t\t\t        <input class=\"form-check-input\" type=\"radio\" name=\"allocation_mode\" value=\"increment\" checked=\"checked\" />\n\t\t\t\t\t\t\t        Incremental\n\t\t\t\t\t\t\t    </label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"form-check form-check-inline\">\n\t\t\t\t\t\t\t    <label class=\"form-check-label\">\n\t\t\t\t\t\t\t        <input class=\"form-check-input\" type=\"radio\" name=\"allocation_mode\" value=\"random\" />\n\t\t\t\t\t\t\t        Random\n\t\t\t\t\t\t\t    </label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"form-check form-check-inline\">\n\t\t\t\t\t\t\t    <label class=\"form-check-label\">\n\t\t\t\t\t\t\t        <input class=\"form-check-input\" type=\"radio\" name=\"allocation_mode\" value=\"explicit\" />\n\t\t\t\t\t\t\t        Manual\n\t\t\t\t\t\t\t    </label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group row show-if-allocation-mode increment random\">\n\t\t\t\t\t\t<label for=\"select-reservation-create-domain\" class=\"col-sm-2 col-form-label\">\n\t\t\t\t\t\t\tDomain:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<div class=\"col-sm-10\">\n\t\t\t\t\t\t\t<select id=\"select-reservation-create-domain\" class=\"form-control\" readonly=\"readonly\">\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group row show-if-allocation-mode increment random\">\n\t\t\t\t\t\t<label for=\"select-reservation-create-range\" class=\"col-sm-2 col-form-label\">\n\t\t\t\t\t\t\tRange:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<div class=\"col-sm-10\">\n\t\t\t\t\t\t\t<select id=\"select-reservation-create-range\" class=\"form-control\" name=\"range\" readonly=\"readonly\">\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group row show-if-allocation-mode explicit\">\n\t\t\t\t\t\t<label for=\"select-reservation-create-address\" class=\"col-sm-2 col-form-label\">\n\t\t\t\t\t\t\tAddress:\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<div class=\"col-sm-10\">\n                            <input id=\"select-reservation-create-address\" name=\"address\" class=\"form-control\" type=\"text\" placeholder=\"127.0.0.1\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-footer\">\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">\n\t\t\t\t\t\tClose\n\t\t\t\t\t</button>\n\t\t\t\t\t<button type=\"submit\" class=\"btn btn-primary disabled\">\n\t\t\t\t\t\t<i class=\"fas fa-plus\"></i>\n\t\t\t\t\t\tCreate Reservation\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["log-viewer"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<h2>Logs</h2>\n<div class=\"log-content\">\n    <table class=\"log-entries\">\n    </table>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["oauth/edit"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("bits/forms", false, "oauth/edit", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("forms", t_1);
output += "\n<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-desktop\"></i>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        Edit OAuth client: ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "friendly_name"), env.opts.autoescape);
output += "\n        ";
;
}
else {
output += "\n        Create new OAuth client\n        ";
;
}
output += "\n    </h4>\n    <div class=\"col text-right\">\n        <a class=\"btn btn-info btn-cancel-edits\" href=\"oauth\" rel=\"internal\">\n            <i class=\"fas fa-undo-alt\"></i>\n            Return to Client List\n        </a>\n    </div>\n</div>\n\n<div class=\"row\">\n    <form name=\"client\" method=\"";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "put";
;
}
else {
output += "post";
;
}
output += "\" data-transport=\"api\" action=\"oauth";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
;
}
else {
output += "/client";
;
}
output += "\" class=\"form-horizontal\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        <div class=\"form-group row\">\n            <label for=\"input-site-id\" class=\"col-sm-2 col-form-label\">\n                ID:\n            </label>\n            <div class=\"col-sm-10\">\n                <input readonly=\"readonly\" name=\"id\" type=\"text\" class=\"form-control\" id=\"input-site-id\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" />\n            </div>\n        </div>\n        ";
;
}
output += "\n        <div class=\"form-group row\">\n            <label for=\"input-client-name\" class=\"col-sm-2 col-form-label\">\n                Friendly Name:\n            </label>\n            <div class=\"col-sm-10\">\n                <input name=\"friendly_name\" type=\"text\" class=\"form-control\" id=\"input-client-name\" placeholder=\"Kirk's Raspberry Pi\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "friendly_name"), env.opts.autoescape);
output += "\" />\n                <p class=\"text-muted help-block\">\n                    Human-readable name for this client. This won't affect the client ID.\n                </p>\n            </div>\n        </div>\n\n        <div class=\"form-group row\">\n            <label for=\"input-client-name\" class=\"col-sm-2 col-form-label\">\n                Abilities:\n            </label>\n            <div class=\"col-sm-10\">\n                ";
var t_4;
t_4 = "scope";
frame.set("field_name", t_4, true);
if(frame.topLevel) {
context.setVariable("field_name", t_4);
}
if(frame.topLevel) {
context.addExport("field_name", t_4);
}
output += "\n                ";
if(runtime.contextOrFrameLookup(context, frame, "scope")) {
output += "\n                    ";
var t_5;
t_5 = (lineno = 49, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "scope")),"split"), "scope[\"split\"]", context, [" "]));
frame.set("abilities", t_5, true);
if(frame.topLevel) {
context.setVariable("abilities", t_5);
}
if(frame.topLevel) {
context.addExport("abilities", t_5);
}
output += "\n                ";
;
}
else {
output += "\n                    ";
var t_6;
t_6 = [];
frame.set("abilities", t_6, true);
if(frame.topLevel) {
context.setVariable("abilities", t_6);
}
if(frame.topLevel) {
context.addExport("abilities", t_6);
}
output += "\n                ";
;
}
output += "\n                ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("bits/abilities", false, "oauth/edit", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
callback(null,t_7);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
callback(null,t_9);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n            </div>\n        </div>\n\n        <div class=\"form-group row form-actions\">\n            <div class=\"col-sm-10 offset-sm-2\">\n                <button type=\"submit\" class=\"btn btn-primary\">\n                    <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-save\"></i>\n                    Save Client\n                </button>\n            </div>\n        </div>\n    </form>\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n    <div class=\"log-container\" data-thing=\"client\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\"></div>\n    ";
;
}
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["range/edit"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("bits/forms", false, "range/edit", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("forms", t_1);
output += "\n<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-globe-americas\"></i>\n        <a href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"id"), env.opts.autoescape);
output += "\" rel=\"internal\">Edit domain: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"name"), env.opts.autoescape);
output += "</a>\n        &raquo;\n        <i class=\"fas fa-network\"></i>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        Edit range: ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\n        ";
;
}
else {
output += "\n        Create new range\n        ";
;
}
output += "\n    </h4>\n    <div class=\"col text-right\">\n        <a class=\"btn btn-info btn-cancel-edits\" href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"id"), env.opts.autoescape);
output += "\" rel=\"internal\">\n            <i class=\"fas fa-undo-alt\"></i>\n            Return to domain: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"name"), env.opts.autoescape);
output += "\n        </a>\n    </div>\n</div>\n<div class=\"row py-3\">\n\t<div class=\"col\">\n        <form name=\"range\" method=\"";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "put";
;
}
else {
output += "post";
;
}
output += "\" data-transport=\"api\" action=\"range";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
;
}
output += "\" class=\"form-horizontal\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-range-id\" class=\"col-sm-2 col-form-label\">\n                    ID:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input readonly=\"readonly\" name=\"id\" type=\"text\" class=\"form-control\" id=\"input-range-id\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            ";
;
}
else {
output += "\n            <input type=\"hidden\" name=\"domain\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"id"), env.opts.autoescape);
output += "\" />\n            ";
;
}
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-range-name\" class=\"col-sm-2 col-form-label\">\n                    Name:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"name\" type=\"text\" class=\"form-control\" id=\"input-range-name\" placeholder=\"Commissioned Starships\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            <div class=\"form-group row\">\n                <label for=\"input-range-inet4-start\" class=\"col-sm-2 col-form-label\">\n                    IPv4 address pool:\n                </label>\n                <div class=\"col-sm-10\">\n                    <div class=\"input-group\">\n                        <input aria-label=\"IPv4 pool beginning address\" name=\"inet4_start\" type=\"text\" class=\"form-control\" id=\"input-range-inet4-start\" placeholder=\"172.32.2.0\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inet4_start"), env.opts.autoescape);
output += "\" />\n                        <div class=\"input-group-prepend\">\n                            <span class=\"input-group-text\">&mdash;</span>\n                        </div>\n                        <input aria-label=\"IPv4 pool ending address\" name=\"inet4_end\" type=\"text\" class=\"form-control\" id=\"input-range-inet4-end\" placeholder=\"172.32.3.250\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inet4_end"), env.opts.autoescape);
output += "\" />\n                    </div>\n                    ";
if(!runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                    <p class=\"help-block text-muted\">\n                        Must lie within the domain's network: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"inet4_address"), env.opts.autoescape);
output += "/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"inet4_prefixlen"), env.opts.autoescape);
output += "\n                    </p>\n                    ";
;
}
output += "\n                </div>\n            </div>\n            <div class=\"form-group row\">\n                <label for=\"input-range-inet6-start\" class=\"col-sm-2 col-form-label\">\n                    IPv6 address pool:\n                </label>\n                <div class=\"col-sm-10\">\n                    <div class=\"input-group\">\n                        <input aria-label=\"IPv6 pool beginning address\" name=\"inet6_start\" type=\"text\" class=\"form-control\" id=\"input-range-inet6-start\" placeholder=\"2600:3f05:c70:1602::1\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inet6_start"), env.opts.autoescape);
output += "\" />\n                        <div class=\"input-group-prepend\">\n                            <span class=\"input-group-text\">&mdash;</span>\n                        </div>\n                        <input aria-label=\"IPv6 pool ending address\" name=\"inet6_end\" type=\"text\" class=\"form-control\" id=\"input-range-inet6-end\" placeholder=\"2600:3f05:c70:1602::1fff:fffe\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "inet6_end"), env.opts.autoescape);
output += "\" />\n                    </div>\n                    ";
if(!runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                    <p class=\"help-block text-muted\">\n                        Must lie within the domain's network: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"inet6_address"), env.opts.autoescape);
output += "/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"inet6_prefixlen"), env.opts.autoescape);
output += "\n                    </p>\n                    ";
;
}
output += "\n                </div>\n            </div>\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n            <div class=\"form-group row\">\n                <label class=\"col-sm-2 col-form-label\">\n                    Reservations:\n                </label>\n                <div class=\"col-sm-10\">\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "reservations") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "reservations")),"length") > 0) {
output += "\n                    <ul class=\"child-link-list\">\n                        ";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "reservations");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("reservation", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n                        <li>\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_7),"iface")),"host")),"id"), env.opts.autoescape);
output += "/interface/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"iface")),"id"), env.opts.autoescape);
output += "\">\n                                ";
output += runtime.suppressValue(runtime.memberLookup((t_7),"address"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_7),"iface")),"host")),"name"), env.opts.autoescape);
output += ":";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"iface")),"name"), env.opts.autoescape);
output += "\n                            </a>\n                        </li>\n                        ";
;
}
}
frame = frame.pop();
output += "\n                    </ul>\n                    ";
;
}
output += "\n                    <p class=\"form-control-static\">Add reservations by editing host interfaces.</p>\n                </div>\n            </div>\n            ";
;
}
output += "\n\n            <div class=\"form-group row form-actions\">\n                <div class=\"col-sm-10 offset-sm-2\">\n                    <button type=\"submit\" class=\"btn btn-primary\">\n                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-save\"></i>\n                        Save Range\n                    </button>\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n                    <a class=\"btn btn-danger\" rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "domain")),"id"), env.opts.autoescape);
output += "/range/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "/delete\">\n                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-trash\"></i>\n                        Delete Range\n                    </a>\n                    ";
;
}
output += "\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["search/results"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("bits/forms", false, "search/results", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("forms", t_1);
output += "\n<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-search\"></i>\n        Search for: ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "term"), env.opts.autoescape);
output += "\n    </h4>\n</div>\n\n<div class=\"row py-3\">\n    <div class=\"col\">\n        ";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "results");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_4;
if(runtime.isArray(t_6)) {
var t_5 = t_6.length;
for(t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4][0];
frame.set("[object Object]", t_6[t_4][0]);
var t_8 = t_6[t_4][1];
frame.set("[object Object]", t_6[t_4][1]);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n            ";
frame = frame.push();
var t_11 = t_8;
if(t_11) {t_11 = runtime.fromIterator(t_11);
var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("entry", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n                <div class=\"row search-result\">\n                    <div class=\"result-title\">\n                        ";
if(t_7 == "Site") {
output += "\n                            <span class=\"badge badge-primary\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-building\"></i>\n                                Site\n                            </span>\n                            <a rel=\"internal\" href=\"site/";
output += runtime.suppressValue(runtime.memberLookup((t_12),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "</a>\n                        ";
;
}
else {
if(t_7 == "Domain") {
output += "\n                            <span class=\"badge badge-success\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-globe-americas\"></i>\n                                Domain\n                            </span>\n                            <a rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((t_12),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "</a>\n                        ";
;
}
else {
if(t_7 == "Host") {
output += "\n                            <span class=\"badge badge-warning\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-desktop\"></i>\n                                Host\n                            </span>\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((t_12),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "</a>\n                        ";
;
}
else {
if(t_7 == "Iface") {
output += "\n                            <span class=\"badge badge-dark\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-microchip\"></i>\n                                Interface\n                            </span>\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"host")),"id"), env.opts.autoescape);
output += "/interface/";
output += runtime.suppressValue(runtime.memberLookup((t_12),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "</a>\n                            on host\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"host")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"host")),"name"), env.opts.autoescape);
output += "</a>\n                        ";
;
}
else {
if(t_7 == "Reservation") {
output += "\n                            <span class=\"badge badge-light\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-tag\"></i>\n                                Reservation\n                            </span>\n                            ";
output += runtime.suppressValue(runtime.memberLookup((t_12),"address"), env.opts.autoescape);
output += "\n                            for interface\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_12),"iface")),"host")),"id"), env.opts.autoescape);
output += "/interface/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"iface")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"iface")),"name"), env.opts.autoescape);
output += "</a>\n                            on host\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_12),"iface")),"host")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_12),"iface")),"host")),"name"), env.opts.autoescape);
output += "</a>\n                        ";
;
}
else {
if(t_7 == "Range") {
output += "\n                            <span class=\"badge badge-info\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-list-ol\"></i>\n                                Range\n                            </span>\n                            <a rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"domain")),"id"), env.opts.autoescape);
output += "/range/";
output += runtime.suppressValue(runtime.memberLookup((t_12),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"name"), env.opts.autoescape);
output += "</a>\n                            in domain\n                            <a rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"domain")),"id"), env.opts.autoescape);
output += "\">\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_12),"domain")),"name"), env.opts.autoescape);
output += "\n                            </a>\n                        ";
;
}
;
}
;
}
;
}
;
}
;
}
output += "\n                    </div>\n                </div>\n            ";
;
}
}
frame = frame.pop();
output += "\n        ";
;
}
} else {
t_4 = -1;
var t_5 = runtime.keys(t_6).length;
for(var t_13 in t_6) {
t_4++;
var t_14 = t_6[t_13];
frame.set("dtype", t_13);
frame.set("entries", t_14);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n            ";
frame = frame.push();
var t_17 = t_14;
if(t_17) {t_17 = runtime.fromIterator(t_17);
var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("entry", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\n                <div class=\"row search-result\">\n                    <div class=\"result-title\">\n                        ";
if(t_13 == "Site") {
output += "\n                            <span class=\"badge badge-primary\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-building\"></i>\n                                Site\n                            </span>\n                            <a rel=\"internal\" href=\"site/";
output += runtime.suppressValue(runtime.memberLookup((t_18),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_18),"name"), env.opts.autoescape);
output += "</a>\n                        ";
;
}
else {
if(t_13 == "Domain") {
output += "\n                            <span class=\"badge badge-success\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-globe-americas\"></i>\n                                Domain\n                            </span>\n                            <a rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((t_18),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_18),"name"), env.opts.autoescape);
output += "</a>\n                        ";
;
}
else {
if(t_13 == "Host") {
output += "\n                            <span class=\"badge badge-warning\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-desktop\"></i>\n                                Host\n                            </span>\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((t_18),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_18),"name"), env.opts.autoescape);
output += "</a>\n                        ";
;
}
else {
if(t_13 == "Iface") {
output += "\n                            <span class=\"badge badge-dark\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-microchip\"></i>\n                                Interface\n                            </span>\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"host")),"id"), env.opts.autoescape);
output += "/interface/";
output += runtime.suppressValue(runtime.memberLookup((t_18),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_18),"name"), env.opts.autoescape);
output += "</a>\n                            on host\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"host")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"host")),"name"), env.opts.autoescape);
output += "</a>\n                        ";
;
}
else {
if(t_13 == "Reservation") {
output += "\n                            <span class=\"badge badge-light\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-tag\"></i>\n                                Reservation\n                            </span>\n                            ";
output += runtime.suppressValue(runtime.memberLookup((t_18),"address"), env.opts.autoescape);
output += "\n                            for interface\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_18),"iface")),"host")),"id"), env.opts.autoescape);
output += "/interface/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"iface")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"iface")),"name"), env.opts.autoescape);
output += "</a>\n                            on host\n                            <a rel=\"internal\" href=\"host/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_18),"iface")),"host")),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_18),"iface")),"host")),"name"), env.opts.autoescape);
output += "</a>\n                        ";
;
}
else {
if(t_13 == "Range") {
output += "\n                            <span class=\"badge badge-info\">\n                                <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-list-ol\"></i>\n                                Range\n                            </span>\n                            <a rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"domain")),"id"), env.opts.autoescape);
output += "/range/";
output += runtime.suppressValue(runtime.memberLookup((t_18),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_18),"name"), env.opts.autoescape);
output += "</a>\n                            in domain\n                            <a rel=\"internal\" href=\"domain/";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"domain")),"id"), env.opts.autoescape);
output += "\">\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_18),"domain")),"name"), env.opts.autoescape);
output += "\n                            </a>\n                        ";
;
}
;
}
;
}
;
}
;
}
;
}
output += "\n                    </div>\n                </div>\n            ";
;
}
}
frame = frame.pop();
output += "\n        ";
;
}
}
}
frame = frame.pop();
output += "\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["site/edit"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("bits/forms", false, "site/edit", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("forms", t_1);
output += "\n<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-building\"></i>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        Edit site: ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\n        ";
;
}
else {
output += "\n        Create new site\n        ";
;
}
output += "\n    </h4>\n    <div class=\"col text-right\">\n        <a class=\"btn btn-info btn-cancel-edits\" href=\"sites\" rel=\"internal\">\n            <i class=\"fas fa-undo-alt\"></i>\n            Return to Site List\n        </a>\n    </div>\n</div>\n\n<div class=\"row py-3\">\n\t<div class=\"col\">\n        <form name=\"site\" method=\"";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "put";
;
}
else {
output += "post";
;
}
output += "\" data-transport=\"api\" action=\"site";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
;
}
output += "\" class=\"form-horizontal\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-site-id\" class=\"col-sm-2 col-form-label\">\n                    ID:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input readonly=\"readonly\" name=\"id\" type=\"text\" class=\"form-control\" id=\"input-site-id\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            ";
;
}
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-site-name\" class=\"col-sm-2 col-form-label\">\n                    Name:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"name\" type=\"text\" class=\"form-control\" id=\"input-site-name\" placeholder=\"Vulcan\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n\n            <div class=\"form-group row\">\n                <label for=\"input-site-asn\" class=\"col-sm-2 col-form-label\">\n                    ASN:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"asn\" type=\"text\" class=\"form-control\" id=\"input-site-asn\" placeholder=\"65001\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "asn"), env.opts.autoescape);
output += "\" />\n                    <p class=\"help-block\">Use only private ASNs - 64512-65534 and 4200000000-4294967294.</p>\n                </div>\n            </div>\n\n            <div class=\"form-group row form-actions\">\n                <div class=\"col-sm-10 offset-sm-2\">\n                    <button type=\"submit\" class=\"btn btn-primary\">\n                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-save\"></i>\n                        Save Site\n                    </button>\n                </div>\n            </div>\n        </form>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        <div class=\"log-container\" data-thing=\"site\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\"></div>\n        ";
;
}
output += "\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["tag-editor"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<h3>Tags</h3>\n<div class=\"thing-tags\" data-thing-type=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "thing"), env.opts.autoescape);
output += "\" data-thing-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "thing_id"), env.opts.autoescape);
output += "\">\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tags")),"length") > 0) {
output += "\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "tags");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("tag", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("bits/tag-entry", false, "tag-editor", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
callback(null,t_5);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
callback(null,t_7);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n        ";
});
}
}
frame = frame.pop();
output += "\n    ";
;
}
else {
output += "\n        <div class=\"row no-tags-placeholder\">\n            <div class=\"col-12\">\n                <p>This ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "thing"), env.opts.autoescape);
output += " doesn't have any tags yet.</p>\n            </div>\n        </div>\n    ";
;
}
output += "\n    <div class=\"form-group row col-12 ctr-add-tag\">\n        <a class=\"btn btn-success btn-insert-tag\">\n            <i class=\"fa fa-plus\"></i>\n            <span class=\"sr-only\">Add Tag</span>\n        </a>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["user/edit"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("bits/forms", false, "user/edit", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("forms", t_1);
output += "\n<div class=\"row\">\n    <h4 class=\"col-lg-auto\">\n        <i class=\"fas fa-user\"></i>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        Edit user: ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "principal"), env.opts.autoescape);
output += "\n        ";
;
}
else {
output += "\n        Create new user\n        ";
;
}
output += "\n    </h4>\n    <div class=\"col text-right\">\n        <a class=\"btn btn-info btn-cancel-edits\" href=\"users\" rel=\"internal\">\n            <i class=\"fas fa-undo-alt\"></i>\n            Return to User List\n        </a>\n    </div>\n</div>\n\n<div class=\"card\">\n\t<div class=\"card-body\">\n\n        <form name=\"user\" method=\"";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "put";
;
}
else {
output += "post";
;
}
output += "\" data-transport=\"api\" action=\"user";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "/";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
;
}
output += "\" class=\"form-horizontal\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n            <div class=\"form-group row\">\n                <label for=\"input-site-id\" class=\"col-sm-2 col-form-label\">\n                    ID:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input readonly=\"readonly\" name=\"id\" type=\"text\" class=\"form-control\" id=\"input-site-id\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n            ";
;
}
output += "\n\n            <div class=\"form-group row\">\n                <label for=\"input-site-name\" class=\"col-sm-2 col-form-label\">\n                    Authorization Source:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"authorizer\" type=\"text\" class=\"form-control\" id=\"input-user-authorizer\" placeholder=\"ThinAirAuthorizer\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "authorizer"), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n\n            <div class=\"form-group row\">\n                <label for=\"input-site-name\" class=\"col-sm-2 col-form-label\">\n                    Primary identifier:\n                </label>\n                <div class=\"col-sm-10\">\n                    <input name=\"principal\" type=\"text\" class=\"form-control\" id=\"input-user-principal\" placeholder=\"jtkirk\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "principal"), env.opts.autoescape);
output += "\" />\n                    <p class=\"help-block text-muted\">\n                        This is the identity that will be provided to Machines by the authorization plugin. This is typically only changed\n                        if the user is renamed, or similar circumstances.\n                    </p>\n                </div>\n            </div>\n\n            <div class=\"form-group row\">\n            <label for=\"input-client-name\" class=\"col-sm-2 col-form-label\">\n                Abilities:\n            </label>\n            <div class=\"col-sm-10\">\n                ";
var t_4;
t_4 = "abilities";
frame.set("field_name", t_4, true);
if(frame.topLevel) {
context.setVariable("field_name", t_4);
}
if(frame.topLevel) {
context.addExport("field_name", t_4);
}
output += "\n                ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("bits/abilities", false, "user/edit", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
callback(null,t_5);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
callback(null,t_7);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n                <p class=\"help-block text-muted\">\n                    <strong>Note:</strong> Authenticator plugins can set user\n                    abilities as well. The list provided by the authenticator\n                    plugin will be merged with abilities given here.\n                </p>\n            </div>\n        </div>\n\n            <div class=\"form-group row\">\n                <label class=\"col-sm-2 col-form-label\">\n                    Options:\n                </label>\n                <div class=\"col-sm-10\">\n                    <div class=\"form-check\">\n                        <label class=\"form-check-label\">\n                            <input class=\"form-check-input\" type=\"checkbox\" name=\"flags[]\" value=\"quarantine\" ";
if(runtime.inOperator("quarantine",runtime.contextOrFrameLookup(context, frame, "flags"))) {
output += "checked=\"checked\"";
;
}
output += " />\n                            <strong>Quarantine:</strong> Quarantine all of the user's hosts, preventing\n                            them from accessing the network on domains with the captive portal enabled.\n                            This overrides the host-level quarantine flag.\n                        </label>\n                    </div>\n                    <div class=\"form-check\">\n                        <label class=\"form-check-label\">\n                            <input class=\"form-check-input\" type=\"checkbox\" name=\"flags[]\" value=\"noninteractive\" ";
if(runtime.inOperator("noninteractive",runtime.contextOrFrameLookup(context, frame, "flags"))) {
output += "checked=\"checked\"";
;
}
output += " />\n                            <strong>Non-interactive user:</strong> Prevent the user from using\n                            Machines interactively. Registered hosts maintain network access,\n                            and the user can still add new devices by associating them with an\n                            EAP-enabled network.\n                        </label>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"form-group row form-actions\">\n                <div class=\"col-sm-10 offset-sm-2\">\n                    <button type=\"submit\" class=\"btn btn-primary\">\n                        <i class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fas"), env.opts.autoescape);
output += " fa-fw fa-save\"></i>\n                        Save User\n                    </button>\n                </div>\n            </div>\n        </form>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "id")) {
output += "\n        <div class=\"log-container\" data-thing=\"user\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\"></div>\n        ";
;
}
output += "\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
